import 'react';
import { b as bundle_es } from './bundle.es-e92e2388.js';
import './tslib.es6-aa46b4f8.js';
export { D as DeviceType, a as DeviceTypeContext } from './index.esm-e9799703.js';
import 'react-measure';
import 'throttle-debounce';
import 'react-dom';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'react-router-dom';
import 'intersection-observer';
import 'react-html-parser';
export { ActionableContent } from './components/actionable-content/index.js';
export { Badge } from './components/badge/index.js';
export { BadgeRanking } from './components/badge-ranking/index.js';
export { BadgeText } from './components/badge-text/index.js';
export { Body } from './components/body/index.js';
export { Breadcrumb } from './components/breadcrumb/index.js';
export { BreadcrumbGroup } from './components/breadcrumb-group/index.js';
export { Button } from './components/button/index.js';
export { ButtonFloating } from './components/button-floating/index.js';
export { ButtonIcon } from './components/button-icon/index.js';
export { ButtonLayout } from './components/button-layout/index.js';
export { ButtonToggle } from './components/button-toggle/index.js';
export { Caption } from './components/caption/index.js';
export { Card } from './components/card/index.js';
export { Carousel } from './components/carousel/index.js';
export { Checkbox } from './components/checkbox/index.js';
export { CheckboxGroup } from './components/checkbox-group/index.js';
export { Chip } from './components/chip/index.js';
export { ChipGroup } from './components/chip-group/index.js';
export { ChipGroupProductTile } from './components/chip-group-product-tile/index.js';
export { CollectionGrid } from './components/collection-grid/index.js';
export { CollectionList } from './components/collection-list/index.js';
export { CollectionListHorizontal } from './components/collection-list-horizontal/index.js';
export { ContentAlignment } from './components/content-alignment/index.js';
export { ContentsCard } from './components/contents-card/index.js';
export { DescriptionList } from './components/description-list/index.js';
export { Display } from './components/display/index.js';
export { Drawer } from './components/drawer/index.js';
export { Dropdown } from './components/dropdown/index.js';
export { ExpandUtility } from './components/expand-utility/index.js';
export { FlagText } from './components/flag-text/index.js';
export { CmsFloatingTicker } from './components/cms-floating-ticker/index.js';
export { Flyout } from './components/flyout/index.js';
export { FlyoutNavigation } from './components/flyout-navigation/index.js';
export { FlyoutSelect } from './components/flyout-select/index.js';
export { Footer } from './components/footer/index.js';
export { FormRow } from './components/form-row/index.js';
export { FormRowGroup } from './components/form-row-group/index.js';
export { Graph } from './components/graph/index.js';
import './components/grid/index.js';
export { HeaderOverlay } from './components/header-overlay/index.js';
export { HeaderPage } from './components/header-page/index.js';
export { HeaderSection } from './components/header-section/index.js';
export { HintError } from './components/hint-error/index.js';
export { HintText } from './components/hint-text/index.js';
export { Icon } from './components/icon/index.js';
export { IconTypography } from './components/icon-typography/index.js';
export { Image } from './components/image/index.js';
export { ImageEnhancements } from './components/image-enhancements/index.js';
export { ImageOverlay } from './components/image-overlay/index.js';
export { ImageTypography } from './components/image-typography/index.js';
export { Keyline } from './components/keyline/index.js';
export { Label } from './components/label/index.js';
export { LabelInput } from './components/label-input/index.js';
export { Layout } from './components/layout/index.js';
export { LayoutWrapper } from './components/layout-wrapper/index.js';
export { LinkCell } from './components/link-cell/index.js';
export { LinkImage } from './components/link-image/index.js';
export { LinkImageGroup } from './components/link-image-group/index.js';
export { LinkNavigation } from './components/link-navigation/index.js';
export { LinkNavigationGroup } from './components/link-navigation-group/index.js';
export { LinkPrimaryNav } from './components/link-primary-nav/index.js';
export { LinkRegion } from './components/link-region/index.js';
export { LinkText } from './components/link-text/index.js';
export { LinkTextGroup } from './components/link-text-group/index.js';
export { List } from './components/list/index.js';
export { StyleUserInfo } from './components/style-user-info/index.js';
export { LoadingIndicator } from './components/loading-indicator/index.js';
export { MediaBanner } from './components/media-banner/index.js';
export { MediaObject } from './components/media-object/index.js';
export { Modal } from './components/modal/index.js';
export { NavigationHeader } from './components/navigation-header/index.js';
export { NavigationRibbon } from './components/navigation-ribbon/index.js';
export { NoImage } from './components/no-image/index.js';
export { OverlayBackdrop } from './components/overlay-backdrop/index.js';
export { OverlayBody } from './components/overlay-body/index.js';
export { PinnedContainer } from './components/pinned-container/index.js';
export { Price } from './components/price/index.js';
export { QueryText } from './components/query-text/index.js';
export { Radio } from './components/radio/index.js';
export { RadioGroup } from './components/radio-group/index.js';
export { RatingStatic } from './components/rating-static/index.js';
export { Review } from './components/review/index.js';
export { ScaleInput } from './components/scale-input/index.js';
export { Search } from './components/search/index.js';
export { Selector } from './components/selector/index.js';
export { SelectorGroup } from './components/selector-group/index.js';
export { Sheet } from './components/sheet/index.js';
export { ShowMore } from './components/show-more/index.js';
export { Spacer } from './components/spacer/index.js';
export { Stepper } from './components/stepper/index.js';
export { StepperGroup } from './components/stepper-group/index.js';
export { Tab } from './components/tab/index.js';
export { TabGroup } from './components/tab-group/index.js';
export { Table } from './components/table/index.js';
export { Tag } from './components/tag/index.js';
export { TemplateFixedPanel } from './components/template-fixed-panel/index.js';
export { TemplateInformation } from './components/template-information/index.js';
export { TextArea } from './components/text-area/index.js';
export { TextField } from './components/text-field/index.js';
export { Tile } from './components/tile/index.js';
export { Title } from './components/title/index.js';
export { Toast } from './components/toast/index.js';
export { Tooltip } from './components/tooltip/index.js';
export { Typeahead } from './components/typeahead/index.js';
export { CmsVerticalScroll } from './components/cms-vertical-scroll/index.js';
export { VideoInline } from './components/video-inline/index.js';
export { GenderTabs } from './components/gender-tabs/index.js';
export { StylingGrid } from './components/styling-grid/index.js';
export { StickyContainer } from './components/sticky-container/index.js';
export { GutterContainer } from './components/gutter-container/index.js';
export { UtilityBar } from './components/utility-bar/index.js';
export { ProductTile } from './components/product-tile/index.js';
export { FilterLayout } from './components/filter-layout/index.js';
export { TemplateILP } from './components/template-ilp/index.js';
export { Accordion } from './components/accordion/index.js';
export { TagFilter } from './components/tag-filter/index.js';
export { TagFilterGroup } from './components/tag-filter-group/index.js';
export { RatingInput } from './components/rating-input/index.js';
export { ScaleStatic } from './components/scale-static/index.js';
export { ScaleStaticItem } from './components/scale-static-item/index.js';
export { TemplatePDP } from './components/template-pdp/index.js';
export { MediaGallery } from './components/media-gallery/index.js';
export { CmsSpacer } from './components/cms-spacer/index.js';
export { CmsLinkText } from './components/cms-link-text/index.js';
export { CmsLink } from './components/cms-link/index.js';
export { CmsFooterLinkItem } from './components/cms-footer-link-item/index.js';
export { CmsFooterLinkGroup } from './components/cms-footer-link-group/index.js';
export { CmsFooter } from './components/cms-footer/index.js';
export { CmsImagePlusText } from './components/cms-image-plus-text/index.js';
export { CmsImagePlusTextCollection } from './components/cms-image-plus-text-collection/index.js';
export { TemplateFullGutter } from './components/template-full-gutter/index.js';
export { TemplateMediaInformation } from './components/template-media-information/index.js';
export { CmsCategoryImage } from './components/cms-category-image/index.js';
export { CmsCategoryImageContainer } from './components/cms-category-image-container/index.js';
export { CmsImage } from './components/cms-image/index.js';
export { CmsVideoInline } from './components/cms-video-inline/index.js';
export { ProductCollection } from './components/product-collection/index.js';
export { CmsLinkButton } from './components/cms-link-button/index.js';
export { CmsLinkButtonContainer } from './components/cms-link-button-container/index.js';
export { CmsAccordionListItem } from './components/cms-accordion-list-item/index.js';
export { CmsAccordionList } from './components/cms-accordion-list/index.js';
export { CmsAccordion } from './components/cms-accordion/index.js';
export { CmsTab } from './components/cms-tab/index.js';
export { CmsTabs } from './components/cms-tabs/index.js';
export { CmsMediaBanner } from './components/cms-media-banner/index.js';
export { CmsTransitionButton } from './components/cms-transition-button/index.js';
export { CmsTicker } from './components/cms-ticker/index.js';
export { CmsContentsCard } from './components/cms-contents-card/index.js';
export { CmsBreadcrumb } from './components/cms-breadcrumb/index.js';
export { CmsBreadcrumbs } from './components/cms-breadcrumbs/index.js';
export { CmsMediaCarousel } from './components/cms-media-carousel/index.js';
export { CmsAnnotation } from './components/cms-annotation/index.js';
export { CmsAccordionGroup } from './components/cms-accordion-group/index.js';
export { CmsNavigationHeaderFlyout } from './components/cms-navigation-header-flyout/index.js';
export { CmsGenderLinksContainer } from './components/cms-gender-links-container/index.js';
export { CmsFloatingTickers } from './components/cms-floating-tickers/index.js';
export { CmsHorizontalRule } from './components/cms-horizontal-rule/index.js';
export { CmsAnchor } from './components/cms-anchor/index.js';
export { CmsUserReview } from './components/cms-user-review/index.js';
export { CmsTappableItem } from './components/cms-tappable-item/index.js';
export { CmsTappableGrid } from './components/cms-tappable-grid/index.js';
export { CmsHeading } from './components/cms-heading/index.js';
export { CmsSnsButton } from './components/cms-sns-button/index.js';
export { CmsSnsButtons } from './components/cms-sns-buttons/index.js';
export { CmsList } from './components/cms-list/index.js';
export { ItemTag } from './components/item-tag/index.js';
export { ItemTags } from './components/item-tags/index.js';
export { CmsContentVisibility } from './components/cms-content-visibility/index.js';
export { CmsText } from './components/cms-text/index.js';
export { FileInput } from './components/file-input/index.js';
export { CmsSmartBanner } from './components/cms-smart-banner/index.js';
export { CmsBannerCollection } from './components/cms-banner-collection/index.js';
export { SearchHistoryItem } from './components/search-history-item/index.js';
export { FixedPanel } from './components/fixed-panel/index.js';
export { BalloonTip } from './components/balloon-tip/index.js';
export { BalloonTipContainer } from './components/balloon-tip-container/index.js';
export { CmsQuoteReview } from './components/cms-quote-review/index.js';
export { CmsQuoteReviewGroup } from './components/cms-quote-review-group/index.js';
export { ProductTable } from './components/product-table/index.js';
export { ImagePlusProductText } from './components/image-plus-product-text/index.js';
export { ButtonToggleGroup } from './components/button-toggle-group/index.js';
export { ComparisonTable } from './components/comparison-table/index.js';
export { TypeaheadGroup } from './components/typeahead-group/index.js';
export { CmsSelectedStore } from './components/cms-selected-store/index.js';
export { DataTableCell } from './components/data-table-cell/index.js';
export { DataTableRow } from './components/data-table-row/index.js';
export { DataTableBody } from './components/data-table-body/index.js';
export { DataTable } from './components/data-table/index.js';
export { Skeleton } from './components/skeleton/index.js';
export { CmsPromotionBanner } from './components/cms-promotion-banner/index.js';
export { CmsFooterInformation } from './components/cms-footer-information/index.js';
export { Tabs } from './components/tabs/index.js';
export { TemplateNavigation } from './components/template-navigation/index.js';
export { BottomNavigation } from './components/bottom-navigation/index.js';
export { Heading } from './components/heading/index.js';
export { FloatingTicker } from './components/floating-ticker/index.js';
export { Link } from './components/link/index.js';
export { ImagePlusText } from './components/image-plus-text/index.js';
export { ImagePlusTextCollection } from './components/image-plus-text-collection/index.js';
export { CategoryList } from './components/category-list/index.js';
export { ClassItem } from './components/class-item/index.js';
export { ClassList } from './components/class-list/index.js';
export { VerticalScroll } from './components/vertical-scroll/index.js';
export { TemplateHome } from './components/template-home/index.js';
export { VerticalScrollGroup } from './components/vertical-scroll-group/index.js';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var pxToRem = bundle_es.pxToRem;

var updateKeys = function updateKeys() {
  var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
    return x;
  };
  return function (obj) {
    return Object.entries(obj).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, transform(key), value));
    }, {});
  };
};

var updateValues = function updateValues() {
  var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
    return x;
  };
  return function (obj) {
    return Object.entries(obj).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, key, transform(value)));
    }, {});
  };
};

var updateConvertorValues = function updateConvertorValues() {
  var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
    return x;
  };
  return function (obj) {
    return Object.entries(obj).reduce(function (acc, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "".concat(key, "-rgb"), transform(value)));
    }, {});
  };
};

var updateKeyAndValue = function updateKeyAndValue(obj) {
  return Object.entries(obj).reduce(function (acc, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        value = _ref8[1];

    return _objectSpread2(_objectSpread2({}, acc), value);
  }, {});
};

var getPxValueToRem = function getPxValueToRem(rootFontSize) {
  return function (value) {
    return pxToRem(value, rootFontSize);
  };
};

var valueToString = function valueToString(value) {
  return "".concat(value);
};

var addPxToValue = function addPxToValue(value) {
  return "".concat(value, "px");
};

var addMsToValue = function addMsToValue(value) {
  return "".concat(value, "ms");
};

var hexToRgb = function hexToRgb(hex) {
  var _ref9 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex) || [],
      _ref10 = _slicedToArray(_ref9, 4),
      match = _ref10[0],
      r = _ref10[1],
      g = _ref10[2],
      b = _ref10[3];

  return match ? "".concat(parseInt(r, 16), ", ").concat(parseInt(g, 16), ", ").concat(parseInt(b, 16)) : null;
};

var cssEnvVariables_utils = {
  getPxValueToRem: getPxValueToRem,
  updateKeys: updateKeys,
  updateValues: updateValues,
  updateKeyAndValue: updateKeyAndValue,
  updateConvertorValues: updateConvertorValues,
  addPxToValue: addPxToValue,
  addMsToValue: addMsToValue,
  valueToString: valueToString,
  hexToRgb: hexToRgb
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var animations = createCommonjsModule(function (module) {
  module.exports.animationEasings = {}; // This is the most common easing curve.

  module.exports.animationEasings.animateEaseInOut = 'cubic-bezier(0.4, 0, 0.2, 1)'; // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.

  module.exports.animationEasings.animateEaseOut = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Objects leave the screen at full velocity. They do not decelerate when off-screen.

  module.exports.animationEasings.animateEaseIn = 'cubic-bezier(0.4, 0, 1, 1)'; // The sharp curve is used by objects that may return to the screen at any time.

  module.exports.animationEasings.animateEaseSharp = 'cubic-bezier(0.4, 0, 0.6, 1)';
  module.exports.animationDurations = {};
  module.exports.animationDurations.animateDurationMicro = 180;
  module.exports.animationDurations.animateDurationNormal = 300;
  module.exports.animationDurations.animateDurationMacro = 500;
  module.exports.animationDurations.animateDurationShortest = 150;
  module.exports.animationDurations.animateDurationShorter = 200;
  module.exports.animationDurations.animateDurationShort = 250; // most basic recommended timing

  module.exports.animationDurations.animateDurationStandard = 300; // this is to be used in complex animations

  module.exports.animationDurations.animateDurationComplex = 375; // recommended when something is entering screen

  module.exports.animationDurations.animateDurationEnter = 225; // recommended when something is leaving screen

  module.exports.animationDurations.animateDurationLeave = 195;
});

var mqSmallScreenMaxWidthLimit = 599;
var mqMediumScreenMinWidthLimit = 600;
var mqMediumScreenMaxWidthLimit = 959;
var mqLargeScreenMinWidthLimit = 960;
var breakpoints = {
  mqSmallScreenMaxWidthLimit: mqSmallScreenMaxWidthLimit,
  mqMediumScreenMinWidthLimit: mqMediumScreenMinWidthLimit,
  mqMediumScreenMaxWidthLimit: mqMediumScreenMaxWidthLimit,
  mqLargeScreenMinWidthLimit: mqLargeScreenMinWidthLimit
};

var columnCountSm = 4;
var columnCountMd = 12;
var columnCountLg = 12;
var columns = {
  columnCountSm: columnCountSm,
  columnCountMd: columnCountMd,
  columnCountLg: columnCountLg
};

var pageBgColor = '#FFFFFF';
var rootFontSize = 16;
var minTargetSize = 44;
var base = {
  pageBgColor: pageBgColor,
  rootFontSize: rootFontSize,
  minTargetSize: minTargetSize
};

var titleFontEn = 'UniqloProBold, system-ui, -apple-system, sans-serif';
var titleFontJa = '"ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var regularFontEn = 'UniqloProRegular, sans-serif';
var lightFontEn = 'UniqloProLight, system-ui, -apple-system, sans-serif';
var bodyFontEn = "'Helvetica Neue', Helvetica, Arial, system-ui, -apple-system, sans-serif";
var bodyFontJa = '"ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var font = {
  titleFontEn: titleFontEn,
  titleFontJa: titleFontJa,
  regularFontEn: regularFontEn,
  lightFontEn: lightFontEn,
  bodyFontEn: bodyFontEn,
  bodyFontJa: bodyFontJa
};

var FONT_WEIGHT_LIGHT = 300;
var FONT_WEIGHT_REGULAR = 400;
var FONT_WEIGHT_MEDIUM = 500;
var FONT_WEIGHT_SEMI_BOLD = 600;
var FONT_WEIGHT_BOLD = 700;
var FONT_WEIGHT_EXTRA_BOLD = 800;
var fontWeightLight = FONT_WEIGHT_LIGHT;
var fontWeightRegular = FONT_WEIGHT_REGULAR;
var fontWeightMedium = FONT_WEIGHT_MEDIUM;
var fontWeightSemiBold = FONT_WEIGHT_SEMI_BOLD;
var fontWeightBold = FONT_WEIGHT_BOLD;
var fontWeightExtraBold = FONT_WEIGHT_EXTRA_BOLD;
var fontWeight = {
  fontWeightLight: fontWeightLight,
  fontWeightRegular: fontWeightRegular,
  fontWeightMedium: fontWeightMedium,
  fontWeightSemiBold: fontWeightSemiBold,
  fontWeightBold: fontWeightBold,
  fontWeightExtraBold: fontWeightExtraBold
};

var gridSizeLg = 1200;
var gridSizeLgLimitWithFixedMargin = 1248;
var gridSizeLgLimitWithAutoMargin = 1249;
var grid = {
  gridSizeLg: gridSizeLg,
  gridSizeLgLimitWithFixedMargin: gridSizeLgLimitWithFixedMargin,
  gridSizeLgLimitWithAutoMargin: gridSizeLgLimitWithAutoMargin
};

var line_height_01 = 1;
var line_height_02 = 1.1;
var line_height_03 = 1.2;
var line_height_04 = 1.4;
var line_height_05 = 1.5;
var lineHeight = {
  line_height_01: line_height_01,
  line_height_02: line_height_02,
  line_height_03: line_height_03,
  line_height_04: line_height_04,
  line_height_05: line_height_05
};

var rootFontSize$1 = base.rootFontSize;
var letterSpacingUniqloPro = rootFontSize$1 / 40;
var letterSpacing = {
  letterSpacingUniqloPro: letterSpacingUniqloPro
};

var BORDER_PRIMARY_OUTLINE_COLOR = '#000000';
var BORDER_PRIMARY_OUTLINE_HOVER_COLOR = '#2A2A2A';
var BORDER_NOTICEABLE_COLOR = '#005DB5';
var BORDER_NOTICEABLE_HOVER_COLOR = '#006ED7';
var BORDER_INTERACTIVE_OUTLINE_COLOR = '#767676';
var BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR = '#5D5D5D';
var BORDER_LINES_COLOR = '#DADADA';
var BORDER_LINES_HOVER_COLOR = '#DADADA';
var BORDER_FOCUS_COLOR = '#005DB5';
var BORDER_FOCUS_HOVER_COLOR = '#006ED7';
var BORDER_ERROR_COLOR = '#EE0000';
var BORDER_ERROR_HOVER_COLOR = '#DD3535';
var BORDER_BACKGROUND_COLOR = '#000000';
var BORDER_SECONDARY_COLOR = '#6A6A6A';
var BORDER_SELECTED_COLOR = '#000000';
var BORDER_SELECTED_HOVER_COLOR = '#2A2A2A';
var borderPrimaryOutlineColor = BORDER_PRIMARY_OUTLINE_COLOR;
var borderPrimaryOutlineHoverColor = BORDER_PRIMARY_OUTLINE_HOVER_COLOR;
var borderNoticeableColor = BORDER_NOTICEABLE_COLOR;
var borderNoticeableHoverColor = BORDER_NOTICEABLE_HOVER_COLOR;
var borderInteractiveOutlineColor = BORDER_INTERACTIVE_OUTLINE_COLOR;
var borderInteractiveOutlineHoverColor = BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR;
var borderLinesColor = BORDER_LINES_COLOR;
var borderLinesHoverColor = BORDER_LINES_HOVER_COLOR;
var borderFocusColor = BORDER_FOCUS_COLOR;
var borderFocusHoverColor = BORDER_FOCUS_HOVER_COLOR;
var borderErrorColor = BORDER_ERROR_COLOR;
var borderErrorHoverColor = BORDER_ERROR_HOVER_COLOR;
var borderBackgroundColor = BORDER_BACKGROUND_COLOR;
var borderSecondaryColor = BORDER_SECONDARY_COLOR;
var borderSelectedColor = BORDER_SELECTED_COLOR;
var borderSelectedHoverColor = BORDER_SELECTED_HOVER_COLOR;
var border = {
  borderPrimaryOutlineColor: borderPrimaryOutlineColor,
  borderPrimaryOutlineHoverColor: borderPrimaryOutlineHoverColor,
  borderNoticeableColor: borderNoticeableColor,
  borderNoticeableHoverColor: borderNoticeableHoverColor,
  borderInteractiveOutlineColor: borderInteractiveOutlineColor,
  borderInteractiveOutlineHoverColor: borderInteractiveOutlineHoverColor,
  borderLinesColor: borderLinesColor,
  borderLinesHoverColor: borderLinesHoverColor,
  borderFocusColor: borderFocusColor,
  borderFocusHoverColor: borderFocusHoverColor,
  borderErrorColor: borderErrorColor,
  borderErrorHoverColor: borderErrorHoverColor,
  borderBackgroundColor: borderBackgroundColor,
  borderSecondaryColor: borderSecondaryColor,
  borderSelectedColor: borderSelectedColor,
  borderSelectedHoverColor: borderSelectedHoverColor
};

var FILL_ATTENTION_COLOR = '#EE0000';
var FILL_ATTENTION_HOVER_COLOR = '#EF5555';
var FILL_PRIMARY_COLOR = '#000000';
var FILL_PRIMARY_HOVER_COLOR = '#2A2A2A';
var FILL_SECONDARY_COLOR = '#FFFFFF';
var FILL_SECONDARY_HOVER_COLOR = '#FFFFFF';
var FILL_TERTIARY_COLOR = '#474747';
var FILL_NOTICEABLE_COLOR = '#005DB5';
var FILL_NOTICEABLE_HOVER_COLOR = '#006ED7';
var FILL_INTERACTIVE_COLOR = '#ABABAB';
var FILL_INTERACTIVE_HOVER_COLOR = '#BCBCBC';
var FILL_DISABLED_COLOR = '#DADADA';
var FILL_DISABLED_HOVER_COLOR = '#DADADA';
var FILL_ERROR_COLOR = '#EE0000';
var FILL_ERROR_HOVER_COLOR = '#EF5555';
var FILL_SELECTED_COLOR = '#000000';
var FILL_SELECTED_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_TAB_COLOR = '#000000';
var FILL_BACKGROUND_COLOR = '#F4F4F4';
var FILL_BACKGROUND_HOVER_COLOR = '#F4F4F4';
var FILL_BACKGROUND_BALLOON_TIP_COLOR = 'rgba(0, 0, 0, 0.85)';
var FILL_SELECTED_TAB_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_STAR_COLOR = '#000000';
var FILL_SELECTED_STAR_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_HEART_COLOR = '#EE0000';
var FILL_SELECTED_HEART_HOVER_COLOR = '#DD3535';
var FILL_POSITIVE_COLOR = '#00AB0F';
var FILL_BACKGROUND_SELECTED_COLOR = '#F4F4F4';
var FILL_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.5)';
var FILL_SKELETON_COLOR = '#F4F4F4';
var FILL_SKELETON_HIGHLIGHT_COLOR = '#FAFAFA';
var fillAttentionColor = FILL_ATTENTION_COLOR;
var fillAttentionHoverColor = FILL_ATTENTION_HOVER_COLOR;
var fillPrimaryColor = FILL_PRIMARY_COLOR;
var fillPrimaryHoverColor = FILL_PRIMARY_HOVER_COLOR;
var fillSecondaryColor = FILL_SECONDARY_COLOR;
var fillSecondaryHoverColor = FILL_SECONDARY_HOVER_COLOR;
var fillTertiaryColor = FILL_TERTIARY_COLOR;
var fillNoticeableColor = FILL_NOTICEABLE_COLOR;
var fillNoticeableHoverColor = FILL_NOTICEABLE_HOVER_COLOR;
var fillInteractiveColor = FILL_INTERACTIVE_COLOR;
var fillInteractiveHoverColor = FILL_INTERACTIVE_HOVER_COLOR;
var fillDisabledColor = FILL_DISABLED_COLOR;
var fillDisabledHoverColor = FILL_DISABLED_HOVER_COLOR;
var fillErrorColor = FILL_ERROR_COLOR;
var fillErrorHoverColor = FILL_ERROR_HOVER_COLOR;
var fillSelectedColor = FILL_SELECTED_COLOR;
var fillSelectedHoverColor = FILL_SELECTED_HOVER_COLOR;
var fillSelectedTabColor = FILL_SELECTED_TAB_COLOR;
var fillBackgroundColor = FILL_BACKGROUND_COLOR;
var fillBackgroundHoverColor = FILL_BACKGROUND_HOVER_COLOR;
var fillBackgroundBalloonTipColor = FILL_BACKGROUND_BALLOON_TIP_COLOR;
var fillSelectedTabHoverColor = FILL_SELECTED_TAB_HOVER_COLOR;
var fillSelectedStarColor = FILL_SELECTED_STAR_COLOR;
var fillSelectedStarHoverColor = FILL_SELECTED_STAR_HOVER_COLOR;
var fillSelectedHeartColor = FILL_SELECTED_HEART_COLOR;
var fillSelectedHeartHoverColor = FILL_SELECTED_HEART_HOVER_COLOR;
var fillPositiveColor = FILL_POSITIVE_COLOR;
var fillBackgroundSelectedColor = FILL_BACKGROUND_SELECTED_COLOR;
var fillOverlayColor = FILL_OVERLAY_COLOR;
var fillSkeletonColor = FILL_SKELETON_COLOR;
var fillSkeletonHighlightColor = FILL_SKELETON_HIGHLIGHT_COLOR;
var fill = {
  fillAttentionColor: fillAttentionColor,
  fillAttentionHoverColor: fillAttentionHoverColor,
  fillPrimaryColor: fillPrimaryColor,
  fillPrimaryHoverColor: fillPrimaryHoverColor,
  fillSecondaryColor: fillSecondaryColor,
  fillSecondaryHoverColor: fillSecondaryHoverColor,
  fillTertiaryColor: fillTertiaryColor,
  fillNoticeableColor: fillNoticeableColor,
  fillNoticeableHoverColor: fillNoticeableHoverColor,
  fillInteractiveColor: fillInteractiveColor,
  fillInteractiveHoverColor: fillInteractiveHoverColor,
  fillDisabledColor: fillDisabledColor,
  fillDisabledHoverColor: fillDisabledHoverColor,
  fillErrorColor: fillErrorColor,
  fillErrorHoverColor: fillErrorHoverColor,
  fillSelectedColor: fillSelectedColor,
  fillSelectedHoverColor: fillSelectedHoverColor,
  fillSelectedTabColor: fillSelectedTabColor,
  fillBackgroundColor: fillBackgroundColor,
  fillBackgroundHoverColor: fillBackgroundHoverColor,
  fillBackgroundBalloonTipColor: fillBackgroundBalloonTipColor,
  fillSelectedTabHoverColor: fillSelectedTabHoverColor,
  fillSelectedStarColor: fillSelectedStarColor,
  fillSelectedStarHoverColor: fillSelectedStarHoverColor,
  fillSelectedHeartColor: fillSelectedHeartColor,
  fillSelectedHeartHoverColor: fillSelectedHeartHoverColor,
  fillPositiveColor: fillPositiveColor,
  fillBackgroundSelectedColor: fillBackgroundSelectedColor,
  fillOverlayColor: fillOverlayColor,
  fillSkeletonColor: fillSkeletonColor,
  fillSkeletonHighlightColor: fillSkeletonHighlightColor
};

var TEXT_PRIMARY_DARK_COLOR = '#000000';
var TEXT_PRIMARY_DARK_HOVER_COLOR = '#2A2A2A';
var TEXT_PRIMARY_LIGHT_COLOR = '#FFFFFF';
var TEXT_PRIMARY_LIGHT_HOVER_COLOR = '#FFFFFF';
var TEXT_SECONDARY_COLOR = '#6A6A6A';
var TEXT_SECONDARY_HOVER_COLOR = '#919191';
var TEXT_NOTICEABLE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_HOVER_COLOR = '#006ED7';
var TEXT_DISABLED_COLOR = '#ABABAB';
var TEXT_DISABLED_HOVER_COLOR = '#ABABAB';
var TEXT_ERROR_COLOR = '#EE0000';
var TEXT_ERROR_HOVER_COLOR = '#EF5555';
var TEXT_PROMOTIONAL_COLOR = '#EE0000';
var TEXT_PROMOTIONAL_HOVER_COLOR = '#EF5555';
var TEXT_PLACEHOLDER_COLOR = '#767676';
var TEXT_PLACEHOLDER_HOVER_COLOR = '#767676';
var TEXT_TERTIARY_COLOR = '#767676';
var TEXT_SELECTED_TAB_NAVIGATION_COLOR = '#000000';
var TEXT_POSITIVE_COLOR = '#008A24';
var TEXT_NOTICEABLE_BLUE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_BLUE_HOVER_COLOR = '#006ED7';
var TEXT_NOTICEABLE_BLACK_COLOR = '#000000';
var textPrimaryDarkColor = TEXT_PRIMARY_DARK_COLOR;
var textPrimaryDarkHoverColor = TEXT_PRIMARY_DARK_HOVER_COLOR;
var textPrimaryLightColor = TEXT_PRIMARY_LIGHT_COLOR;
var textPrimaryLightHoverColor = TEXT_PRIMARY_LIGHT_HOVER_COLOR;
var textSecondaryColor = TEXT_SECONDARY_COLOR;
var textSecondaryHoverColor = TEXT_SECONDARY_HOVER_COLOR;
var textNoticeableColor = TEXT_NOTICEABLE_COLOR;
var textNoticeableHoverColor = TEXT_NOTICEABLE_HOVER_COLOR;
var textDisabledColor = TEXT_DISABLED_COLOR;
var textDisabledHoverColor = TEXT_DISABLED_HOVER_COLOR;
var textErrorColor = TEXT_ERROR_COLOR;
var textErrorHoverColor = TEXT_ERROR_HOVER_COLOR;
var textPromotionalColor = TEXT_PROMOTIONAL_COLOR;
var textPromotionalHoverColor = TEXT_PROMOTIONAL_HOVER_COLOR;
var textPlaceholderColor = TEXT_PLACEHOLDER_COLOR;
var textPlaceholderHoverColor = TEXT_PLACEHOLDER_HOVER_COLOR;
var textTertiaryColor = TEXT_TERTIARY_COLOR;
var textSelectedTabNavigationColor = TEXT_SELECTED_TAB_NAVIGATION_COLOR;
var textPositiveColor = TEXT_POSITIVE_COLOR;
var textNoticeableBlueColor = TEXT_NOTICEABLE_BLUE_COLOR;
var textNoticeableBlueHoverColor = TEXT_NOTICEABLE_BLUE_HOVER_COLOR;
var textNoticeableBlackColor = TEXT_NOTICEABLE_BLACK_COLOR;
var text = {
  textPrimaryDarkColor: textPrimaryDarkColor,
  textPrimaryDarkHoverColor: textPrimaryDarkHoverColor,
  textPrimaryLightColor: textPrimaryLightColor,
  textPrimaryLightHoverColor: textPrimaryLightHoverColor,
  textSecondaryColor: textSecondaryColor,
  textSecondaryHoverColor: textSecondaryHoverColor,
  textNoticeableColor: textNoticeableColor,
  textNoticeableHoverColor: textNoticeableHoverColor,
  textDisabledColor: textDisabledColor,
  textDisabledHoverColor: textDisabledHoverColor,
  textErrorColor: textErrorColor,
  textErrorHoverColor: textErrorHoverColor,
  textPromotionalColor: textPromotionalColor,
  textPromotionalHoverColor: textPromotionalHoverColor,
  textPlaceholderColor: textPlaceholderColor,
  textPlaceholderHoverColor: textPlaceholderHoverColor,
  textTertiaryColor: textTertiaryColor,
  textSelectedTabNavigationColor: textSelectedTabNavigationColor,
  textPositiveColor: textPositiveColor,
  textNoticeableBlueColor: textNoticeableBlueColor,
  textNoticeableBlueHoverColor: textNoticeableBlueHoverColor,
  textNoticeableBlackColor: textNoticeableBlackColor
};

var EFFECTS_BOX_SHADOW_COLOR = '#1B1B1B';
var effectsBoxShadowColor = EFFECTS_BOX_SHADOW_COLOR;
var effects = {
  effectsBoxShadowColor: effectsBoxShadowColor
};

var UI_ATTENTION_DEFAULT_COLOR = '#FF0000';
var UI_ATTENTION_HOVER_COLOR = '#FF5959';
var UI_PRIMARY_DEFAULT_COLOR = '#1B1B1B';
var UI_PRIMARY_HOVER_COLOR = '#6A6A6A';
var UI_SECONDARY_DEFAULT_OUTLINE_COLOR = '#1B1B1B';
var UI_SECONDARY_DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
var UI_SECONDARY_DEFAULT_HOVER_COLOR = '#6A6A6A';
var UI_GLOBAL_BACKGROUND_COLOR = '#F4F4F4';
var UI_GLOBAL_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_FOCUS_COLOR = '#006ED7';
var UI_GLOBAL_FOCUS_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_DISABLED_COLOR = '#DADADA';
var UI_GLOBAL_BORDER_COLOR = '#DADADA';
var UI_GLOBAL_INTERACTIVE_COLOR = '#ABABAB';
var UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR = '#F7F7F7';
var UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR = '#FFFFFF';
var SUPPORTING_GENDER_WOMEN_COLOR = '#FF0000';
var SUPPORTING_GENDER_MEN_COLOR = '#000082';
var SUPPORTING_GENDER_KIDS_COLOR = '#50B4F0';
var SUPPORTING_GENDER_BABY_COLOR = '#96C800';
var SUPPORTING_GENDER_GIRLS_COLOR = '#EB64A5';
var SUPPORTING_GENDER_BOYS_COLOR = '#0091D7';
var COLOR_YELLOW = '#ebbe00';
var uiAttentionDefaultColor = UI_ATTENTION_DEFAULT_COLOR;
var uiAttentionHoverColor = UI_ATTENTION_HOVER_COLOR;
var uiPrimaryDefaultColor = UI_PRIMARY_DEFAULT_COLOR;
var uiPrimaryHoverColor = UI_PRIMARY_HOVER_COLOR;
var uiSecondaryDefaultOutlineColor = UI_SECONDARY_DEFAULT_OUTLINE_COLOR;
var uiSecondaryDefaultBackgroundColor = UI_SECONDARY_DEFAULT_BACKGROUND_COLOR;
var uiSecondaryDefaultHoverColor = UI_SECONDARY_DEFAULT_HOVER_COLOR;
var uiGlobalBackgroundColor = UI_GLOBAL_BACKGROUND_COLOR;
var uiGlobalErrorColor = UI_GLOBAL_ERROR_COLOR;
var uiGlobalFocusColor = UI_GLOBAL_FOCUS_COLOR;
var uiGlobalFocusErrorColor = UI_GLOBAL_FOCUS_ERROR_COLOR;
var uiGlobalDisabledColor = UI_GLOBAL_DISABLED_COLOR;
var uiGlobalBorderColor = UI_GLOBAL_BORDER_COLOR;
var uiGlobalInteractiveColor = UI_GLOBAL_INTERACTIVE_COLOR;
var uiFormInputsBackgroundPassiveColor = UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR;
var uiFormInputsBackgroundActiveColor = UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR;
var supportingGenderWomenColor = SUPPORTING_GENDER_WOMEN_COLOR;
var supportingGenderMenColor = SUPPORTING_GENDER_MEN_COLOR;
var supportingGenderKidsColor = SUPPORTING_GENDER_KIDS_COLOR;
var supportingGenderBabyColor = SUPPORTING_GENDER_BABY_COLOR;
var supportingGenderGirlsColor = SUPPORTING_GENDER_GIRLS_COLOR;
var supportingGenderBoysColor = SUPPORTING_GENDER_BOYS_COLOR;
var colorYellow = COLOR_YELLOW;
var additionals = {
  uiAttentionDefaultColor: uiAttentionDefaultColor,
  uiAttentionHoverColor: uiAttentionHoverColor,
  uiPrimaryDefaultColor: uiPrimaryDefaultColor,
  uiPrimaryHoverColor: uiPrimaryHoverColor,
  uiSecondaryDefaultOutlineColor: uiSecondaryDefaultOutlineColor,
  uiSecondaryDefaultBackgroundColor: uiSecondaryDefaultBackgroundColor,
  uiSecondaryDefaultHoverColor: uiSecondaryDefaultHoverColor,
  uiGlobalBackgroundColor: uiGlobalBackgroundColor,
  uiGlobalErrorColor: uiGlobalErrorColor,
  uiGlobalFocusColor: uiGlobalFocusColor,
  uiGlobalFocusErrorColor: uiGlobalFocusErrorColor,
  uiGlobalDisabledColor: uiGlobalDisabledColor,
  uiGlobalBorderColor: uiGlobalBorderColor,
  uiGlobalInteractiveColor: uiGlobalInteractiveColor,
  uiFormInputsBackgroundPassiveColor: uiFormInputsBackgroundPassiveColor,
  uiFormInputsBackgroundActiveColor: uiFormInputsBackgroundActiveColor,
  supportingGenderWomenColor: supportingGenderWomenColor,
  supportingGenderMenColor: supportingGenderMenColor,
  supportingGenderKidsColor: supportingGenderKidsColor,
  supportingGenderBabyColor: supportingGenderBabyColor,
  supportingGenderGirlsColor: supportingGenderGirlsColor,
  supportingGenderBoysColor: supportingGenderBoysColor,
  colorYellow: colorYellow
};

var color = {
  border: border,
  fill: fill,
  text: text,
  effects: effects,
  additionals: additionals
};

var DISPLAY1_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY1_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY2_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY2_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY3_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY3_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY4_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY4_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY5_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY5_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DYNAMIC_COLOR_DISABLED = color.text.textDisabledColor;
var DYNAMIC_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_DISABLED = color.text.textDisabledColor;
var TITLE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var FLAG_COLOR_SECONDARY = color.text.textSecondaryColor;
var BADGE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_LARGE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var BADGE_SMALL_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var CAPTION_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_PRIMARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_PRIMARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_PRIMARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_PRIMARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SECONDARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SECONDARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SECONDARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SECONDARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SECONDARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SECONDARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SUPPORTIVE_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SUPPORTIVE_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SUPPORTIVE_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var BODY_STANDARD_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var BODY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var BODY_EMPHASIZED_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var PRICE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_SMALL_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_MEDIUM_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_MEDIUM_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_LARGE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var HINT_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var HINT_COLOR_SECONDARY = color.text.textSecondaryColor;
var HINT_COLOR_DISABLED = color.text.textDisabledColor;
var HINT_COLOR_ERROR = color.text.textErrorColor;
var display1_ColorDisabled = DISPLAY1_COLOR_DISABLED;
var display1_ColorPrimaryDark = DISPLAY1_COLOR_PRIMARY_DARK;
var display2_ColorDisabled = DISPLAY2_COLOR_DISABLED;
var display2_ColorPrimaryDark = DISPLAY2_COLOR_PRIMARY_DARK;
var display3_ColorDisabled = DISPLAY3_COLOR_DISABLED;
var display3_ColorPrimaryDark = DISPLAY3_COLOR_PRIMARY_DARK;
var display4_ColorDisabled = DISPLAY4_COLOR_DISABLED;
var display4_ColorPrimaryDark = DISPLAY4_COLOR_PRIMARY_DARK;
var display5_ColorDisabled = DISPLAY5_COLOR_DISABLED;
var display5_ColorPrimaryDark = DISPLAY5_COLOR_PRIMARY_DARK;
var dynamic_ColorDisabled = DYNAMIC_COLOR_DISABLED;
var dynamic_ColorPrimaryDark = DYNAMIC_COLOR_PRIMARY_DARK;
var titleColorDisabled = TITLE_COLOR_DISABLED;
var titleColorPrimaryDark = TITLE_COLOR_PRIMARY_DARK;
var titleColorPromotional = TITLE_COLOR_PROMOTIONAL;
var flagColorSecondary = FLAG_COLOR_SECONDARY;
var badgeLargeColorPrimaryDark = BADGE_LARGE_COLOR_PRIMARY_DARK;
var badgeSmallColorPrimaryDark = BADGE_SMALL_COLOR_PRIMARY_DARK;
var badgeLargeColorPrimaryLight = BADGE_LARGE_COLOR_PRIMARY_LIGHT;
var badgeSmallColorPrimaryLight = BADGE_SMALL_COLOR_PRIMARY_LIGHT;
var captionStandardColorDisabled = CAPTION_STANDARD_COLOR_DISABLED;
var captionStandardColorError = CAPTION_STANDARD_COLOR_ERROR;
var captionStandardColorPrimaryDark = CAPTION_STANDARD_COLOR_PRIMARY_DARK;
var captionStandardColorPrimaryLight = CAPTION_STANDARD_COLOR_PRIMARY_LIGHT;
var captionStandardColorPromotional = CAPTION_STANDARD_COLOR_PROMOTIONAL;
var captionStandardColorSecondary = CAPTION_STANDARD_COLOR_SECONDARY;
var captionEmphasizedColorDisabled = CAPTION_EMPHASIZED_COLOR_DISABLED;
var captionEmphasizedColorError = CAPTION_EMPHASIZED_COLOR_ERROR;
var captionEmphasizedColorPrimaryDark = CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK;
var captionEmphasizedColorPrimaryLight = CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var captionEmphasizedColorPromotional = CAPTION_EMPHASIZED_COLOR_PROMOTIONAL;
var captionEmphasizedColorSecondary = CAPTION_EMPHASIZED_COLOR_SECONDARY;
var labelPrimaryColorPrimaryDark = LABEL_PRIMARY_COLOR_PRIMARY_DARK;
var labelPrimaryColorPrimaryLight = LABEL_PRIMARY_COLOR_PRIMARY_LIGHT;
var labelPrimaryColorDisabled = LABEL_PRIMARY_COLOR_DISABLED;
var labelPrimaryColorSecondary = LABEL_PRIMARY_COLOR_SECONDARY;
var labelPrimaryColorPrimaryHover = LABEL_PRIMARY_COLOR_PRIMARY_HOVER;
var labelPrimaryColorInteractive = LABEL_PRIMARY_COLOR_INTERACTIVE;
var labelSecondaryColorPrimaryDark = LABEL_SECONDARY_COLOR_PRIMARY_DARK;
var labelSecondaryColorPrimaryLight = LABEL_SECONDARY_COLOR_PRIMARY_LIGHT;
var labelSecondaryColorDisabled = LABEL_SECONDARY_COLOR_DISABLED;
var labelSecondaryColorSecondary = LABEL_SECONDARY_COLOR_SECONDARY;
var labelSecondaryColorPrimaryHover = LABEL_SECONDARY_COLOR_PRIMARY_HOVER;
var labelSecondaryColorInteractive = LABEL_SECONDARY_COLOR_INTERACTIVE;
var labelTertiaryStandardColorPrimaryDark = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK;
var labelTertiaryStandardColorPrimaryLight = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT;
var labelTertiaryStandardColorDisabled = LABEL_TERTIARY_STANDARD_COLOR_DISABLED;
var labelTertiaryStandardColorSecondary = LABEL_TERTIARY_STANDARD_COLOR_SECONDARY;
var labelTertiaryStandardColorPrimaryHover = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER;
var labelTertiaryStandardColorInteractive = LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE;
var labelTertiaryEmphasizedColorPrimaryDark = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK;
var labelTertiaryEmphasizedColorPrimaryLight = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var labelTertiaryEmphasizedColorDisabled = LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED;
var labelTertiaryEmphasizedColorSecondary = LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY;
var labelTertiaryEmphasizedColorPrimaryHover = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var labelTertiaryEmphasizedColorInteractive = LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE;
var labelSupportiveColorPrimaryDark = LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK;
var labelSupportiveColorPrimaryLight = LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT;
var labelSupportiveColorDisabled = LABEL_SUPPORTIVE_COLOR_DISABLED;
var labelSupportiveColorSecondary = LABEL_SUPPORTIVE_COLOR_SECONDARY;
var labelSupportiveColorPrimaryHover = LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER;
var labelSupportiveColorInteractive = LABEL_SUPPORTIVE_COLOR_INTERACTIVE;
var bodyStandardColorPlaceholder = BODY_STANDARD_COLOR_PLACEHOLDER;
var bodyStandardColorDisabled = BODY_STANDARD_COLOR_DISABLED;
var bodyStandardColorError = BODY_STANDARD_COLOR_ERROR;
var bodyStandardColorPrimaryDark = BODY_STANDARD_COLOR_PRIMARY_DARK;
var bodyStandardColorPromotional = BODY_STANDARD_COLOR_PROMOTIONAL;
var bodyStandardColorSecondary = BODY_STANDARD_COLOR_SECONDARY;
var bodyStandardColorPrimaryHover = BODY_STANDARD_COLOR_PRIMARY_HOVER;
var bodyEmphasizedColorPlaceholder = BODY_EMPHASIZED_COLOR_PLACEHOLDER;
var bodyEmphasizedColorDisabled = BODY_EMPHASIZED_COLOR_DISABLED;
var bodyEmphasizedColorError = BODY_EMPHASIZED_COLOR_ERROR;
var bodyEmphasizedColorPrimaryDark = BODY_EMPHASIZED_COLOR_PRIMARY_DARK;
var bodyEmphasizedColorPromotional = BODY_EMPHASIZED_COLOR_PROMOTIONAL;
var bodyEmphasizedColorSecondary = BODY_EMPHASIZED_COLOR_SECONDARY;
var bodyEmphasizedColorPrimaryHover = BODY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var priceSmallColorPrimaryDark = PRICE_SMALL_COLOR_PRIMARY_DARK;
var priceSmallColorPromotional = PRICE_SMALL_COLOR_PROMOTIONAL;
var priceMediumColorPrimaryDark = PRICE_MEDIUM_COLOR_PRIMARY_DARK;
var priceMediumColorPromotional = PRICE_MEDIUM_COLOR_PROMOTIONAL;
var priceLargeColorPrimaryDark = PRICE_LARGE_COLOR_PRIMARY_DARK;
var priceLargeColorPromotional = PRICE_LARGE_COLOR_PROMOTIONAL;
var hintColorPrimaryDark = HINT_COLOR_PRIMARY_DARK;
var hintColorSecondary = HINT_COLOR_SECONDARY;
var hintColorDisabled = HINT_COLOR_DISABLED;
var hintColorError = HINT_COLOR_ERROR;
var typographyColor = {
  display1_ColorDisabled: display1_ColorDisabled,
  display1_ColorPrimaryDark: display1_ColorPrimaryDark,
  display2_ColorDisabled: display2_ColorDisabled,
  display2_ColorPrimaryDark: display2_ColorPrimaryDark,
  display3_ColorDisabled: display3_ColorDisabled,
  display3_ColorPrimaryDark: display3_ColorPrimaryDark,
  display4_ColorDisabled: display4_ColorDisabled,
  display4_ColorPrimaryDark: display4_ColorPrimaryDark,
  display5_ColorDisabled: display5_ColorDisabled,
  display5_ColorPrimaryDark: display5_ColorPrimaryDark,
  dynamic_ColorDisabled: dynamic_ColorDisabled,
  dynamic_ColorPrimaryDark: dynamic_ColorPrimaryDark,
  titleColorDisabled: titleColorDisabled,
  titleColorPrimaryDark: titleColorPrimaryDark,
  titleColorPromotional: titleColorPromotional,
  flagColorSecondary: flagColorSecondary,
  badgeLargeColorPrimaryDark: badgeLargeColorPrimaryDark,
  badgeSmallColorPrimaryDark: badgeSmallColorPrimaryDark,
  badgeLargeColorPrimaryLight: badgeLargeColorPrimaryLight,
  badgeSmallColorPrimaryLight: badgeSmallColorPrimaryLight,
  captionStandardColorDisabled: captionStandardColorDisabled,
  captionStandardColorError: captionStandardColorError,
  captionStandardColorPrimaryDark: captionStandardColorPrimaryDark,
  captionStandardColorPrimaryLight: captionStandardColorPrimaryLight,
  captionStandardColorPromotional: captionStandardColorPromotional,
  captionStandardColorSecondary: captionStandardColorSecondary,
  captionEmphasizedColorDisabled: captionEmphasizedColorDisabled,
  captionEmphasizedColorError: captionEmphasizedColorError,
  captionEmphasizedColorPrimaryDark: captionEmphasizedColorPrimaryDark,
  captionEmphasizedColorPrimaryLight: captionEmphasizedColorPrimaryLight,
  captionEmphasizedColorPromotional: captionEmphasizedColorPromotional,
  captionEmphasizedColorSecondary: captionEmphasizedColorSecondary,
  labelPrimaryColorPrimaryDark: labelPrimaryColorPrimaryDark,
  labelPrimaryColorPrimaryLight: labelPrimaryColorPrimaryLight,
  labelPrimaryColorDisabled: labelPrimaryColorDisabled,
  labelPrimaryColorSecondary: labelPrimaryColorSecondary,
  labelPrimaryColorPrimaryHover: labelPrimaryColorPrimaryHover,
  labelPrimaryColorInteractive: labelPrimaryColorInteractive,
  labelSecondaryColorPrimaryDark: labelSecondaryColorPrimaryDark,
  labelSecondaryColorPrimaryLight: labelSecondaryColorPrimaryLight,
  labelSecondaryColorDisabled: labelSecondaryColorDisabled,
  labelSecondaryColorSecondary: labelSecondaryColorSecondary,
  labelSecondaryColorPrimaryHover: labelSecondaryColorPrimaryHover,
  labelSecondaryColorInteractive: labelSecondaryColorInteractive,
  labelTertiaryStandardColorPrimaryDark: labelTertiaryStandardColorPrimaryDark,
  labelTertiaryStandardColorPrimaryLight: labelTertiaryStandardColorPrimaryLight,
  labelTertiaryStandardColorDisabled: labelTertiaryStandardColorDisabled,
  labelTertiaryStandardColorSecondary: labelTertiaryStandardColorSecondary,
  labelTertiaryStandardColorPrimaryHover: labelTertiaryStandardColorPrimaryHover,
  labelTertiaryStandardColorInteractive: labelTertiaryStandardColorInteractive,
  labelTertiaryEmphasizedColorPrimaryDark: labelTertiaryEmphasizedColorPrimaryDark,
  labelTertiaryEmphasizedColorPrimaryLight: labelTertiaryEmphasizedColorPrimaryLight,
  labelTertiaryEmphasizedColorDisabled: labelTertiaryEmphasizedColorDisabled,
  labelTertiaryEmphasizedColorSecondary: labelTertiaryEmphasizedColorSecondary,
  labelTertiaryEmphasizedColorPrimaryHover: labelTertiaryEmphasizedColorPrimaryHover,
  labelTertiaryEmphasizedColorInteractive: labelTertiaryEmphasizedColorInteractive,
  labelSupportiveColorPrimaryDark: labelSupportiveColorPrimaryDark,
  labelSupportiveColorPrimaryLight: labelSupportiveColorPrimaryLight,
  labelSupportiveColorDisabled: labelSupportiveColorDisabled,
  labelSupportiveColorSecondary: labelSupportiveColorSecondary,
  labelSupportiveColorPrimaryHover: labelSupportiveColorPrimaryHover,
  labelSupportiveColorInteractive: labelSupportiveColorInteractive,
  bodyStandardColorPlaceholder: bodyStandardColorPlaceholder,
  bodyStandardColorDisabled: bodyStandardColorDisabled,
  bodyStandardColorError: bodyStandardColorError,
  bodyStandardColorPrimaryDark: bodyStandardColorPrimaryDark,
  bodyStandardColorPromotional: bodyStandardColorPromotional,
  bodyStandardColorSecondary: bodyStandardColorSecondary,
  bodyStandardColorPrimaryHover: bodyStandardColorPrimaryHover,
  bodyEmphasizedColorPlaceholder: bodyEmphasizedColorPlaceholder,
  bodyEmphasizedColorDisabled: bodyEmphasizedColorDisabled,
  bodyEmphasizedColorError: bodyEmphasizedColorError,
  bodyEmphasizedColorPrimaryDark: bodyEmphasizedColorPrimaryDark,
  bodyEmphasizedColorPromotional: bodyEmphasizedColorPromotional,
  bodyEmphasizedColorSecondary: bodyEmphasizedColorSecondary,
  bodyEmphasizedColorPrimaryHover: bodyEmphasizedColorPrimaryHover,
  priceSmallColorPrimaryDark: priceSmallColorPrimaryDark,
  priceSmallColorPromotional: priceSmallColorPromotional,
  priceMediumColorPrimaryDark: priceMediumColorPrimaryDark,
  priceMediumColorPromotional: priceMediumColorPromotional,
  priceLargeColorPrimaryDark: priceLargeColorPrimaryDark,
  priceLargeColorPromotional: priceLargeColorPromotional,
  hintColorPrimaryDark: hintColorPrimaryDark,
  hintColorSecondary: hintColorSecondary,
  hintColorDisabled: hintColorDisabled,
  hintColorError: hintColorError
};

var rootFontSize$2 = base.rootFontSize;
var SPACING_01 = rootFontSize$2 * 0.25;
var SPACING_02 = rootFontSize$2 * 0.5;
var SPACING_03 = rootFontSize$2 * 0.75;
var SPACING_04 = rootFontSize$2;
var SPACING_05 = rootFontSize$2 * 1.5;
var SPACING_06 = rootFontSize$2 * 2;
var SPACING_07 = rootFontSize$2 * 3.25;
var SPACING_08 = rootFontSize$2 * 5.5;
var SPACING_HALF_GUTTER = rootFontSize$2 * 0.75;
var SPACING_GUTTER = SPACING_HALF_GUTTER * 2;
var SPACING_COLUMN_INSET = rootFontSize$2 * 1.5;
var spacing_01 = SPACING_01;
var spacing_02 = SPACING_02;
var spacing_03 = SPACING_03;
var spacing_04 = SPACING_04;
var spacing_05 = SPACING_05;
var spacing_06 = SPACING_06;
var spacing_07 = SPACING_07;
var spacing_08 = SPACING_08;
var spacingNegative_01 = SPACING_01 * -1;
var spacingNegative_02 = SPACING_02 * -1;
var spacingNegative_03 = SPACING_03 * -1;
var spacingNegative_04 = SPACING_04 * -1;
var spacingNegative_05 = SPACING_05 * -1;
var spacingNegative_06 = SPACING_06 * -1;
var spacingNegative_07 = SPACING_07 * -1;
var spacingNegative_08 = SPACING_08 * -1;
var spacingHalfGutter = SPACING_HALF_GUTTER;
var spacingGutter = SPACING_GUTTER;
var spacingColumnInset = SPACING_COLUMN_INSET;
var spacingRowGap = SPACING_HALF_GUTTER;
var spacingRowGapAtLarge = SPACING_GUTTER + SPACING_COLUMN_INSET;
var spacingGridMarginAtMedium = rootFontSize$2 * 1.5;
var spacingGridMarginAtLarge = rootFontSize$2 * 3;
var spacingGridMarginAtExtraLarge = 'auto';
var spacingGutterSm = rootFontSize$2;
var spacingGutterMd = SPACING_GUTTER;
var spacingGutterLg = SPACING_GUTTER;
var spacingInsetSm = rootFontSize$2;
var spacingInsetMd = rootFontSize$2;
var spacingInsetLg = rootFontSize$2 * 1.5;
var spacingOutsetSm = rootFontSize$2 * 1.25;
var spacingOutsetMd = rootFontSize$2 * 0.75;
var spacingOutsetLg = rootFontSize$2 * 0.75;
var spacing = {
  spacing_01: spacing_01,
  spacing_02: spacing_02,
  spacing_03: spacing_03,
  spacing_04: spacing_04,
  spacing_05: spacing_05,
  spacing_06: spacing_06,
  spacing_07: spacing_07,
  spacing_08: spacing_08,
  spacingNegative_01: spacingNegative_01,
  spacingNegative_02: spacingNegative_02,
  spacingNegative_03: spacingNegative_03,
  spacingNegative_04: spacingNegative_04,
  spacingNegative_05: spacingNegative_05,
  spacingNegative_06: spacingNegative_06,
  spacingNegative_07: spacingNegative_07,
  spacingNegative_08: spacingNegative_08,
  spacingHalfGutter: spacingHalfGutter,
  spacingGutter: spacingGutter,
  spacingColumnInset: spacingColumnInset,
  spacingRowGap: spacingRowGap,
  spacingRowGapAtLarge: spacingRowGapAtLarge,
  spacingGridMarginAtMedium: spacingGridMarginAtMedium,
  spacingGridMarginAtLarge: spacingGridMarginAtLarge,
  spacingGridMarginAtExtraLarge: spacingGridMarginAtExtraLarge,
  spacingGutterSm: spacingGutterSm,
  spacingGutterMd: spacingGutterMd,
  spacingGutterLg: spacingGutterLg,
  spacingInsetSm: spacingInsetSm,
  spacingInsetMd: spacingInsetMd,
  spacingInsetLg: spacingInsetLg,
  spacingOutsetSm: spacingOutsetSm,
  spacingOutsetMd: spacingOutsetMd,
  spacingOutsetLg: spacingOutsetLg
};

var rootFontSize$3 = base.rootFontSize;
var typeScaleLatinMinus_2 = rootFontSize$3 * 0.75;
var typeScaleLatinMinus_1 = rootFontSize$3 * 0.875;
var typeScaleLatinBase = rootFontSize$3 * 1;
var typeScaleLatinPlus_1 = rootFontSize$3 * 1.125;
var typeScaleLatinPlus_2 = rootFontSize$3 * 1.25;
var typeScaleLatinPlus_3 = rootFontSize$3 * 1.5;
var typeScaleLatinPlus_4 = rootFontSize$3 * 1.75;
var typeScaleLatinPlus_5 = rootFontSize$3 * 2;
var typeScaleLatinPlus_6 = rootFontSize$3 * 2.25;
var typeScaleLatinPlus_7 = rootFontSize$3 * 2.625;
var typeScaleLatinPlus_8 = rootFontSize$3 * 3;
var typeScaleLatinPlus_9 = rootFontSize$3 * 3.375;
var typeScaleLatinPlus_10 = rootFontSize$3 * 3.75;
var typeScaleCjkMinus_2 = 11;
var typeScaleCjkMinus_1 = 13;
var typeScaleCjkBase = 15;
var typeScaleCjkPlus_1 = 17;
var typeScaleCjkPlus_2 = 19;
var typeScaleCjkPlus_3 = 22;
var typeScaleCjkPlus_4 = 26;
var typeScaleCjkPlus_5 = 30;
var typeScaleCjkPlus_6 = 36;
var typeScaleCjkPlus_7 = 40;
var typeScaleCjkPlus_8 = 45;
var typeScaleCjkPlus_9 = 51;
var typeScaleCjkPlus_10 = 56;
var typeScale = {
  typeScaleLatinMinus_2: typeScaleLatinMinus_2,
  typeScaleLatinMinus_1: typeScaleLatinMinus_1,
  typeScaleLatinBase: typeScaleLatinBase,
  typeScaleLatinPlus_1: typeScaleLatinPlus_1,
  typeScaleLatinPlus_2: typeScaleLatinPlus_2,
  typeScaleLatinPlus_3: typeScaleLatinPlus_3,
  typeScaleLatinPlus_4: typeScaleLatinPlus_4,
  typeScaleLatinPlus_5: typeScaleLatinPlus_5,
  typeScaleLatinPlus_6: typeScaleLatinPlus_6,
  typeScaleLatinPlus_7: typeScaleLatinPlus_7,
  typeScaleLatinPlus_8: typeScaleLatinPlus_8,
  typeScaleLatinPlus_9: typeScaleLatinPlus_9,
  typeScaleLatinPlus_10: typeScaleLatinPlus_10,
  typeScaleCjkMinus_2: typeScaleCjkMinus_2,
  typeScaleCjkMinus_1: typeScaleCjkMinus_1,
  typeScaleCjkBase: typeScaleCjkBase,
  typeScaleCjkPlus_1: typeScaleCjkPlus_1,
  typeScaleCjkPlus_2: typeScaleCjkPlus_2,
  typeScaleCjkPlus_3: typeScaleCjkPlus_3,
  typeScaleCjkPlus_4: typeScaleCjkPlus_4,
  typeScaleCjkPlus_5: typeScaleCjkPlus_5,
  typeScaleCjkPlus_6: typeScaleCjkPlus_6,
  typeScaleCjkPlus_7: typeScaleCjkPlus_7,
  typeScaleCjkPlus_8: typeScaleCjkPlus_8,
  typeScaleCjkPlus_9: typeScaleCjkPlus_9,
  typeScaleCjkPlus_10: typeScaleCjkPlus_10
};

var SHADOW_FLOATING = '0px 2px 4px rgba(0, 0, 0, 0.2)';
var SHADOW_FLOATING_ER = '0px 0px 10px rgba(0, 0, 0, 0.1)';
var SHADOW_BUTTON_BLACK = '0px 0px 0px 0px #00000000';
var SHADOW_BUTTON_PRIMARY = '0px 0px 0px 0px #00000000';
var SHADOW_OTHER = '0px 2px 2px rgba(0, 0, 0, 0.6)';
var SHADOW_CHIP = '0px 0px 4px rgba(0, 0, 0, 0.8)';
var SHADOW_TEXT_ICON_ER = '0px 1px 1px rgba(0, 0, 0, 0.6)';
var SHADOW_BOTTOM_NAVIGATION_ER = '0px 0px 20px rgba(0, 0, 0, 0.1)';
var shadow_floating = SHADOW_FLOATING;
var shadow_floating_er = SHADOW_FLOATING_ER;
var shadow_button_black = SHADOW_BUTTON_BLACK;
var shadow_button_primary = SHADOW_BUTTON_PRIMARY;
var shadow_other = SHADOW_OTHER;
var shadow_chip = SHADOW_CHIP;
var shadow_text_icon_er = SHADOW_TEXT_ICON_ER;
var shadow_bottom_navigation_er = SHADOW_BOTTOM_NAVIGATION_ER;
var shadow = {
  shadow_floating: shadow_floating,
  shadow_floating_er: shadow_floating_er,
  shadow_button_black: shadow_button_black,
  shadow_button_primary: shadow_button_primary,
  shadow_other: shadow_other,
  shadow_chip: shadow_chip,
  shadow_text_icon_er: shadow_text_icon_er,
  shadow_bottom_navigation_er: shadow_bottom_navigation_er
};

var BORDER_RADIUS_PILL = '999px';
var BORDER_RADIUS_ROUND = '0';
var BORDER_RADIUS_BUTTON_H_32 = '0';
var BORDER_RADIUS_BUTTON_H_40 = '0';
var BORDER_RADIUS_BUTTON_H_50 = '0';
var BORDER_RADIUS_BUTTON_H_52 = '0';
var BORDER_RADIUS_CHIP_LONG_TEXT = '0';
var border_radius_pill = BORDER_RADIUS_PILL;
var border_radius_round = BORDER_RADIUS_ROUND;
var border_radius_button_h_32 = BORDER_RADIUS_BUTTON_H_32;
var border_radius_button_h_40 = BORDER_RADIUS_BUTTON_H_40;
var border_radius_button_h_50 = BORDER_RADIUS_BUTTON_H_50;
var border_radius_button_h_52 = BORDER_RADIUS_BUTTON_H_52;
var border_radius_chip_long_text = BORDER_RADIUS_CHIP_LONG_TEXT;
var borderRadius = {
  border_radius_pill: border_radius_pill,
  border_radius_round: border_radius_round,
  border_radius_button_h_32: border_radius_button_h_32,
  border_radius_button_h_40: border_radius_button_h_40,
  border_radius_button_h_50: border_radius_button_h_50,
  border_radius_button_h_52: border_radius_button_h_52,
  border_radius_chip_long_text: border_radius_chip_long_text
};

var Z_INDEX_BASE_00 = 0;
var Z_INDEX_BASE_01 = 2;
var Z_INDEX_BASE_02 = 4;
var Z_INDEX_BASE_03 = 6;
var Z_INDEX_BASE_04 = 8;
var Z_INDEX_FLAT_00 = 10;
var Z_INDEX_FLAT_01 = 12;
var Z_INDEX_FLAT_02 = 14;
var Z_INDEX_FLAT_03 = 16;
var Z_INDEX_FLAT_04 = 18;
var Z_INDEX_OVERAY_00 = 20;
var Z_INDEX_OVERAY_01 = 22;
var Z_INDEX_OVERAY_02 = 24;
var Z_INDEX_OVERAY_03 = 26;
var Z_INDEX_OVERAY_04 = 28;
var Z_INDEX_FLOATING_00 = 30;
var Z_INDEX_FLOATING_01 = 32;
var Z_INDEX_FLOATING_02 = 34;
var Z_INDEX_FLOATING_03 = 36;
var Z_INDEX_FLOATING_04 = 38;
var Z_INDEX_HEADER_00 = 40;
var Z_INDEX_HEADER_01 = 42;
var Z_INDEX_HEADER_02 = 44;
var Z_INDEX_HEADER_03 = 46;
var Z_INDEX_HEADER_04 = 48;
var Z_INDEX_MODAL_00 = 50;
var Z_INDEX_MODAL_01 = 52;
var Z_INDEX_MODAL_02 = 54;
var Z_INDEX_MODAL_03 = 56;
var Z_INDEX_MODAL_04 = 58;
var zIndexBase_00 = Z_INDEX_BASE_00;
var zIndexBase_01 = Z_INDEX_BASE_01;
var zIndexBase_02 = Z_INDEX_BASE_02;
var zIndexBase_03 = Z_INDEX_BASE_03;
var zIndexBase_04 = Z_INDEX_BASE_04;
var zIndexFlat_00 = Z_INDEX_FLAT_00;
var zIndexFlat_01 = Z_INDEX_FLAT_01;
var zIndexFlat_02 = Z_INDEX_FLAT_02;
var zIndexFlat_03 = Z_INDEX_FLAT_03;
var zIndexFlat_04 = Z_INDEX_FLAT_04;
var zIndexOverlay_00 = Z_INDEX_OVERAY_00;
var zIndexOverlay_01 = Z_INDEX_OVERAY_01;
var zIndexOverlay_02 = Z_INDEX_OVERAY_02;
var zIndexOverlay_03 = Z_INDEX_OVERAY_03;
var zIndexOverlay_04 = Z_INDEX_OVERAY_04;
var zIndexFloating_00 = Z_INDEX_FLOATING_00;
var zIndexFloating_01 = Z_INDEX_FLOATING_01;
var zIndexFloating_02 = Z_INDEX_FLOATING_02;
var zIndexFloating_03 = Z_INDEX_FLOATING_03;
var zIndexFloating_04 = Z_INDEX_FLOATING_04;
var zIndexHeader_00 = Z_INDEX_HEADER_00;
var zIndexHeader_01 = Z_INDEX_HEADER_01;
var zIndexHeader_02 = Z_INDEX_HEADER_02;
var zIndexHeader_03 = Z_INDEX_HEADER_03;
var zIndexHeader_04 = Z_INDEX_HEADER_04;
var zIndexModal_00 = Z_INDEX_MODAL_00;
var zIndexModal_01 = Z_INDEX_MODAL_01;
var zIndexModal_02 = Z_INDEX_MODAL_02;
var zIndexModal_03 = Z_INDEX_MODAL_03;
var zIndexModal_04 = Z_INDEX_MODAL_04;
var zIndex = {
  zIndexBase_00: zIndexBase_00,
  zIndexBase_01: zIndexBase_01,
  zIndexBase_02: zIndexBase_02,
  zIndexBase_03: zIndexBase_03,
  zIndexBase_04: zIndexBase_04,
  zIndexFlat_00: zIndexFlat_00,
  zIndexFlat_01: zIndexFlat_01,
  zIndexFlat_02: zIndexFlat_02,
  zIndexFlat_03: zIndexFlat_03,
  zIndexFlat_04: zIndexFlat_04,
  zIndexOverlay_00: zIndexOverlay_00,
  zIndexOverlay_01: zIndexOverlay_01,
  zIndexOverlay_02: zIndexOverlay_02,
  zIndexOverlay_03: zIndexOverlay_03,
  zIndexOverlay_04: zIndexOverlay_04,
  zIndexFloating_00: zIndexFloating_00,
  zIndexFloating_01: zIndexFloating_01,
  zIndexFloating_02: zIndexFloating_02,
  zIndexFloating_03: zIndexFloating_03,
  zIndexFloating_04: zIndexFloating_04,
  zIndexHeader_00: zIndexHeader_00,
  zIndexHeader_01: zIndexHeader_01,
  zIndexHeader_02: zIndexHeader_02,
  zIndexHeader_03: zIndexHeader_03,
  zIndexHeader_04: zIndexHeader_04,
  zIndexModal_00: zIndexModal_00,
  zIndexModal_01: zIndexModal_01,
  zIndexModal_02: zIndexModal_02,
  zIndexModal_03: zIndexModal_03,
  zIndexModal_04: zIndexModal_04
};

var animationDurations = animations.animationDurations,
    animationEasings = animations.animationEasings;
var rootFontSize$4 = base.rootFontSize,
    pageBgColor$1 = base.pageBgColor,
    minTargetSize$1 = base.minTargetSize;
var designTokens = {
  animationDurations: animationDurations,
  animationEasings: animationEasings,
  breakpoints: breakpoints,
  columns: columns,
  dtColor: color,
  font: font,
  fontWeight: fontWeight,
  grid: grid,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing,
  typographyColor: typographyColor,
  rootFontSize: rootFontSize$4,
  pageBgColor: pageBgColor$1,
  minTargetSize: minTargetSize$1,
  spacing: spacing,
  typeScale: typeScale,
  shadow: shadow,
  borderRadius: borderRadius,
  zIndex: zIndex
};

var productTileChipWidth = 16;
var productTileChipMargin = 6;
var productTileNegativeChipMargin = -6;
var productTileChipSmallWidth = 10;
var productTileChipSmallMargin = 4;
var productTileNegativeChipSmallMargin = -4;

var chip_jsEnvVariables = {
	productTileChipWidth: productTileChipWidth,
	productTileChipMargin: productTileChipMargin,
	productTileNegativeChipMargin: productTileNegativeChipMargin,
	productTileChipSmallWidth: productTileChipSmallWidth,
	productTileChipSmallMargin: productTileChipSmallMargin,
	productTileNegativeChipSmallMargin: productTileNegativeChipSmallMargin
};

var camelCaseToCssVarName = bundle_es.camelCaseToCssVarName;
var updateKeys$1 = cssEnvVariables_utils.updateKeys,
    updateValues$1 = cssEnvVariables_utils.updateValues,
    updateConvertorValues$1 = cssEnvVariables_utils.updateConvertorValues,
    updateKeyAndValue$1 = cssEnvVariables_utils.updateKeyAndValue,
    addPxToValue$1 = cssEnvVariables_utils.addPxToValue,
    getPxValueToRem$1 = cssEnvVariables_utils.getPxValueToRem,
    addMsToValue$1 = cssEnvVariables_utils.addMsToValue,
    valueToString$1 = cssEnvVariables_utils.valueToString,
    hexToRgb$1 = cssEnvVariables_utils.hexToRgb;
var animationDurations$1 = designTokens.animationDurations,
    animationEasings$1 = designTokens.animationEasings,
    breakpoints$1 = designTokens.breakpoints,
    columns$1 = designTokens.columns,
    dtColor = designTokens.dtColor,
    font$1 = designTokens.font,
    fontWeight$1 = designTokens.fontWeight,
    grid$1 = designTokens.grid,
    lineHeight$1 = designTokens.lineHeight,
    letterSpacing$1 = designTokens.letterSpacing,
    rootFontSize$5 = designTokens.rootFontSize,
    minTargetSize$2 = designTokens.minTargetSize,
    spacing$1 = designTokens.spacing,
    typographyColor$1 = designTokens.typographyColor,
    typeScale$1 = designTokens.typeScale,
    shadow$1 = designTokens.shadow,
    borderRadius$1 = designTokens.borderRadius,
    zIndex$1 = designTokens.zIndex;
var objectHexToRgb = updateConvertorValues$1(hexToRgb$1);
var productTileChipWidth$1 = chip_jsEnvVariables.productTileChipWidth,
    productTileChipMargin$1 = chip_jsEnvVariables.productTileChipMargin,
    productTileNegativeChipMargin$1 = chip_jsEnvVariables.productTileNegativeChipMargin;

var spacingGridMarginAtExtraLarge$1 = spacing$1.spacingGridMarginAtExtraLarge,
    spacingVariablesInPx = _objectWithoutProperties(spacing$1, ["spacingGridMarginAtExtraLarge"]);

var pxValueToRem = getPxValueToRem$1(rootFontSize$5);
var addPxToObjectValues = updateValues$1(addPxToValue$1);
var addMsToObjectValues = updateValues$1(addMsToValue$1);
var objectValuesToString = updateValues$1(valueToString$1);
var objectPxValuesToRem = updateValues$1(pxValueToRem);
var objectDtColor = updateKeyAndValue$1(dtColor);

var _map = [addMsToObjectValues(animationDurations$1), animationEasings$1, addPxToObjectValues(breakpoints$1), objectDtColor, objectValuesToString(columns$1), font$1, objectValuesToString(fontWeight$1), addPxToObjectValues(grid$1), objectPxValuesToRem(letterSpacing$1), objectValuesToString(lineHeight$1), objectPxValuesToRem(spacingVariablesInPx), objectPxValuesToRem(typeScale$1), typographyColor$1, objectHexToRgb(dtColor.additionals), objectValuesToString(shadow$1), objectValuesToString(borderRadius$1), objectValuesToString(zIndex$1)].map(updateKeys$1(camelCaseToCssVarName)),
    _map2 = _slicedToArray(_map, 17),
    transformedAnimationDurations = _map2[0],
    transformedAnimationEasings = _map2[1],
    transformedBreakpoints = _map2[2],
    transformedDesignTokenColor = _map2[3],
    transformedColumns = _map2[4],
    transformedFont = _map2[5],
    transformedFontWeight = _map2[6],
    transformedGrid = _map2[7],
    transformedLetterSpacing = _map2[8],
    transformedLineHeight = _map2[9],
    transformedSpacingVariablesInPx = _map2[10],
    transformedTypeScale = _map2[11],
    transformedTypographyColor = _map2[12],
    transformedHexRgbColor = _map2[13],
    transformedShadowValues = _map2[14],
    transformedBorderRadius = _map2[15],
    transformedZIndex = _map2[16];

var environmentVariables = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
  '--root-font-size': "".concat(rootFontSize$5, "px"),
  '--min-target-size': "".concat(minTargetSize$2, "px")
}, transformedAnimationDurations), transformedAnimationEasings), transformedBreakpoints), transformedDesignTokenColor), transformedColumns), transformedFont), transformedFontWeight), transformedGrid), transformedLetterSpacing), transformedLineHeight), transformedSpacingVariablesInPx), transformedHexRgbColor), {}, {
  '--spacing-gridMarginAtExtraLarge': spacingGridMarginAtExtraLarge$1
}, transformedTypeScale), transformedTypographyColor), {}, {
  '--product-tile-chip-width': pxValueToRem(productTileChipWidth$1),
  '--product-tile-chip-margin': pxValueToRem(productTileChipMargin$1),
  '--product-tile-negative-chip-margin': pxValueToRem(productTileNegativeChipMargin$1)
}, transformedShadowValues), transformedBorderRadius), transformedZIndex);

var cssEnvVariables = {
  environmentVariables: environmentVariables
};
var cssEnvVariables_1 = cssEnvVariables.environmentVariables;

var TEXT_PRIMARY_DARK_COLOR$1 = '#1B1B1B';
var TEXT_PRIMARY_LIGHT_COLOR$1 = '#FFFFFF';
var TEXT_SECONDARY_COLOR$1 = '#787878';
var TEXT_DISABLED_COLOR$1 = '#ABABAB';
var TEXT_PROMOTIONAL_COLOR$1 = '#FF0000';
var TEXT_ERROR_COLOR$1 = '#CC0000';
var TEXT_PLACEHOLDER_COLOR$1 = '#787878';
var UI_ATTENTION_DEFAULT_COLOR$1 = '#FF0000';
var UI_ATTENTION_HOVER_COLOR$1 = '#FF5959';
var UI_PRIMARY_DEFAULT_COLOR$1 = '#1B1B1B';
var UI_PRIMARY_HOVER_COLOR$1 = '#6A6A6A';
var UI_SECONDARY_DEFAULT_OUTLINE_COLOR$1 = '#1B1B1B';
var UI_SECONDARY_DEFAULT_BACKGROUND_COLOR$1 = '#FFFFFF';
var UI_SECONDARY_DEFAULT_HOVER_COLOR$1 = '#6A6A6A';
var UI_GLOBAL_BACKGROUND_COLOR$1 = '#F4F4F4';
var UI_GLOBAL_ERROR_COLOR$1 = '#CC0000';
var UI_GLOBAL_FOCUS_COLOR$1 = '#378694';
var UI_GLOBAL_FOCUS_ERROR_COLOR$1 = '#CC0000';
var UI_GLOBAL_DISABLED_COLOR$1 = '#DADADA';
var UI_GLOBAL_BORDER_COLOR$1 = '#DADADA';
var UI_GLOBAL_INTERACTIVE_COLOR$1 = '#ABABAB';
var UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR$1 = '#F7F7F7';
var UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR$1 = '#FFFFFF';
var SUPPORTING_GENDER_WOMEN_COLOR$1 = '#FF0000';
var SUPPORTING_GENDER_MEN_COLOR$1 = '#000082';
var SUPPORTING_GENDER_KIDS_COLOR$1 = '#50B4F0';
var SUPPORTING_GENDER_BABY_COLOR$1 = '#96C800';
var SUPPORTING_GENDER_GIRLS_COLOR$1 = '#EB64A5';
var SUPPORTING_GENDER_BOYS_COLOR$1 = '#0091D7';
var textPrimaryDarkColor$1 = TEXT_PRIMARY_DARK_COLOR$1;
var textPrimaryLightColor$1 = TEXT_PRIMARY_LIGHT_COLOR$1;
var textSecondaryColor$1 = TEXT_SECONDARY_COLOR$1;
var textDisabledColor$1 = TEXT_DISABLED_COLOR$1;
var textPromotionalColor$1 = TEXT_PROMOTIONAL_COLOR$1;
var textErrorColor$1 = TEXT_ERROR_COLOR$1;
var textPlaceholderColor$1 = TEXT_PLACEHOLDER_COLOR$1;
var uiAttentionDefaultColor$1 = UI_ATTENTION_DEFAULT_COLOR$1;
var uiAttentionHoverColor$1 = UI_ATTENTION_HOVER_COLOR$1;
var uiPrimaryDefaultColor$1 = UI_PRIMARY_DEFAULT_COLOR$1;
var uiPrimaryHoverColor$1 = UI_PRIMARY_HOVER_COLOR$1;
var uiSecondaryDefaultOutlineColor$1 = UI_SECONDARY_DEFAULT_OUTLINE_COLOR$1;
var uiSecondaryDefaultBackgroundColor$1 = UI_SECONDARY_DEFAULT_BACKGROUND_COLOR$1;
var uiSecondaryDefaultHoverColor$1 = UI_SECONDARY_DEFAULT_HOVER_COLOR$1;
var uiGlobalBackgroundColor$1 = UI_GLOBAL_BACKGROUND_COLOR$1;
var uiGlobalErrorColor$1 = UI_GLOBAL_ERROR_COLOR$1;
var uiGlobalFocusColor$1 = UI_GLOBAL_FOCUS_COLOR$1;
var uiGlobalFocusErrorColor$1 = UI_GLOBAL_FOCUS_ERROR_COLOR$1;
var uiGlobalDisabledColor$1 = UI_GLOBAL_DISABLED_COLOR$1;
var uiGlobalBorderColor$1 = UI_GLOBAL_BORDER_COLOR$1;
var uiGlobalInteractiveColor$1 = UI_GLOBAL_INTERACTIVE_COLOR$1;
var uiFormInputsBackgroundPassiveColor$1 = UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR$1;
var uiFormInputsBackgroundActiveColor$1 = UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR$1;
var supportingGenderWomenColor$1 = SUPPORTING_GENDER_WOMEN_COLOR$1;
var supportingGenderMenColor$1 = SUPPORTING_GENDER_MEN_COLOR$1;
var supportingGenderKidsColor$1 = SUPPORTING_GENDER_KIDS_COLOR$1;
var supportingGenderBabyColor$1 = SUPPORTING_GENDER_BABY_COLOR$1;
var supportingGenderGirlsColor$1 = SUPPORTING_GENDER_GIRLS_COLOR$1;
var supportingGenderBoysColor$1 = SUPPORTING_GENDER_BOYS_COLOR$1;
/* Start OLD color variables, UXDS-1981 To be removed once transition to new variables is done. */

var COLOR_YELLOW$1 = '#ebbe00';
var colorYellow$1 = COLOR_YELLOW$1;
/* End OLD color variables */

var color$1 = {
  textPrimaryDarkColor: textPrimaryDarkColor$1,
  textPrimaryLightColor: textPrimaryLightColor$1,
  textSecondaryColor: textSecondaryColor$1,
  textDisabledColor: textDisabledColor$1,
  textPromotionalColor: textPromotionalColor$1,
  textErrorColor: textErrorColor$1,
  textPlaceholderColor: textPlaceholderColor$1,
  uiAttentionDefaultColor: uiAttentionDefaultColor$1,
  uiAttentionHoverColor: uiAttentionHoverColor$1,
  uiPrimaryDefaultColor: uiPrimaryDefaultColor$1,
  uiPrimaryHoverColor: uiPrimaryHoverColor$1,
  uiSecondaryDefaultOutlineColor: uiSecondaryDefaultOutlineColor$1,
  uiSecondaryDefaultBackgroundColor: uiSecondaryDefaultBackgroundColor$1,
  uiSecondaryDefaultHoverColor: uiSecondaryDefaultHoverColor$1,
  uiGlobalBackgroundColor: uiGlobalBackgroundColor$1,
  uiGlobalErrorColor: uiGlobalErrorColor$1,
  uiGlobalFocusColor: uiGlobalFocusColor$1,
  uiGlobalFocusErrorColor: uiGlobalFocusErrorColor$1,
  uiGlobalDisabledColor: uiGlobalDisabledColor$1,
  uiGlobalBorderColor: uiGlobalBorderColor$1,
  uiGlobalInteractiveColor: uiGlobalInteractiveColor$1,
  uiFormInputsBackgroundPassiveColor: uiFormInputsBackgroundPassiveColor$1,
  uiFormInputsBackgroundActiveColor: uiFormInputsBackgroundActiveColor$1,
  supportingGenderWomenColor: supportingGenderWomenColor$1,
  supportingGenderMenColor: supportingGenderMenColor$1,
  supportingGenderKidsColor: supportingGenderKidsColor$1,
  supportingGenderBabyColor: supportingGenderBabyColor$1,
  supportingGenderGirlsColor: supportingGenderGirlsColor$1,
  supportingGenderBoysColor: supportingGenderBoysColor$1,
  colorYellow: colorYellow$1
};

var DISPLAY1_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY1_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY2_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY2_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY3_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY3_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY4_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY4_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var TITLE_COLOR_DISABLED$1 = color$1.textDisabledColor;
var TITLE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var TITLE_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var FLAG_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BADGE_LARGE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BADGE_SMALL_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BADGE_LARGE_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var BADGE_SMALL_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var CAPTION_STANDARD_COLOR_ERROR$1 = color$1.textErrorColor;
var CAPTION_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var CAPTION_STANDARD_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var CAPTION_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var CAPTION_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var CAPTION_EMPHASIZED_COLOR_ERROR$1 = color$1.textErrorColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_EMPHASIZED_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var CAPTION_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_PRIMARY_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_PRIMARY_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_PRIMARY_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_PRIMARY_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_SECONDARY_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_SECONDARY_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_SECONDARY_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_SECONDARY_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_SECONDARY_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_SECONDARY_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_TERTIARY_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_TERTIARY_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_SUPPORTIVE_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_SUPPORTIVE_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_SUPPORTIVE_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var BODY_STANDARD_COLOR_PLACEHOLDER$1 = color$1.textPlaceholderColor;
var BODY_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var BODY_STANDARD_COLOR_ERROR$1 = color$1.textErrorColor;
var BODY_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BODY_STANDARD_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var BODY_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BODY_STANDARD_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var BODY_EMPHASIZED_COLOR_PLACEHOLDER$1 = color$1.textPlaceholderColor;
var BODY_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var BODY_EMPHASIZED_COLOR_ERROR$1 = color$1.textErrorColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BODY_EMPHASIZED_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var BODY_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var PRICE_SMALL_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_SMALL_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var PRICE_MEDIUM_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_MEDIUM_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var PRICE_LARGE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_LARGE_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var HINT_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var HINT_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var HINT_COLOR_DISABLED$1 = color$1.textDisabledColor;
var HINT_COLOR_ERROR$1 = color$1.textErrorColor;
var display1_ColorDisabled$1 = DISPLAY1_COLOR_DISABLED$1;
var display1_ColorPrimaryDark$1 = DISPLAY1_COLOR_PRIMARY_DARK$1;
var display2_ColorDisabled$1 = DISPLAY2_COLOR_DISABLED$1;
var display2_ColorPrimaryDark$1 = DISPLAY2_COLOR_PRIMARY_DARK$1;
var display3_ColorDisabled$1 = DISPLAY3_COLOR_DISABLED$1;
var display3_ColorPrimaryDark$1 = DISPLAY3_COLOR_PRIMARY_DARK$1;
var display4_ColorDisabled$1 = DISPLAY4_COLOR_DISABLED$1;
var display4_ColorPrimaryDark$1 = DISPLAY4_COLOR_PRIMARY_DARK$1;
var titleColorDisabled$1 = TITLE_COLOR_DISABLED$1;
var titleColorPrimaryDark$1 = TITLE_COLOR_PRIMARY_DARK$1;
var titleColorPromotional$1 = TITLE_COLOR_PROMOTIONAL$1;
var flagColorSecondary$1 = FLAG_COLOR_SECONDARY$1;
var badgeLargeColorPrimaryDark$1 = BADGE_LARGE_COLOR_PRIMARY_DARK$1;
var badgeSmallColorPrimaryDark$1 = BADGE_SMALL_COLOR_PRIMARY_DARK$1;
var badgeLargeColorPrimaryLight$1 = BADGE_LARGE_COLOR_PRIMARY_LIGHT$1;
var badgeSmallColorPrimaryLight$1 = BADGE_SMALL_COLOR_PRIMARY_LIGHT$1;
var captionStandardColorDisabled$1 = CAPTION_STANDARD_COLOR_DISABLED$1;
var captionStandardColorError$1 = CAPTION_STANDARD_COLOR_ERROR$1;
var captionStandardColorPrimaryDark$1 = CAPTION_STANDARD_COLOR_PRIMARY_DARK$1;
var captionStandardColorPrimaryLight$1 = CAPTION_STANDARD_COLOR_PRIMARY_LIGHT$1;
var captionStandardColorPromotional$1 = CAPTION_STANDARD_COLOR_PROMOTIONAL$1;
var captionStandardColorSecondary$1 = CAPTION_STANDARD_COLOR_SECONDARY$1;
var captionEmphasizedColorDisabled$1 = CAPTION_EMPHASIZED_COLOR_DISABLED$1;
var captionEmphasizedColorError$1 = CAPTION_EMPHASIZED_COLOR_ERROR$1;
var captionEmphasizedColorPrimaryDark$1 = CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var captionEmphasizedColorPrimaryLight$1 = CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT$1;
var captionEmphasizedColorPromotional$1 = CAPTION_EMPHASIZED_COLOR_PROMOTIONAL$1;
var captionEmphasizedColorSecondary$1 = CAPTION_EMPHASIZED_COLOR_SECONDARY$1;
var labelPrimaryColorPrimaryDark$1 = LABEL_PRIMARY_COLOR_PRIMARY_DARK$1;
var labelPrimaryColorPrimaryLight$1 = LABEL_PRIMARY_COLOR_PRIMARY_LIGHT$1;
var labelPrimaryColorDisabled$1 = LABEL_PRIMARY_COLOR_DISABLED$1;
var labelPrimaryColorSecondary$1 = LABEL_PRIMARY_COLOR_SECONDARY$1;
var labelPrimaryColorPrimaryHover$1 = LABEL_PRIMARY_COLOR_PRIMARY_HOVER$1;
var labelPrimaryColorInteractive$1 = LABEL_PRIMARY_COLOR_INTERACTIVE$1;
var labelSecondaryColorPrimaryDark$1 = LABEL_SECONDARY_COLOR_PRIMARY_DARK$1;
var labelSecondaryColorPrimaryLight$1 = LABEL_SECONDARY_COLOR_PRIMARY_LIGHT$1;
var labelSecondaryColorDisabled$1 = LABEL_SECONDARY_COLOR_DISABLED$1;
var labelSecondaryColorSecondary$1 = LABEL_SECONDARY_COLOR_SECONDARY$1;
var labelSecondaryColorPrimaryHover$1 = LABEL_SECONDARY_COLOR_PRIMARY_HOVER$1;
var labelSecondaryColorInteractive$1 = LABEL_SECONDARY_COLOR_INTERACTIVE$1;
var labelTertiaryStandardColorPrimaryDark$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK$1;
var labelTertiaryStandardColorPrimaryLight$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT$1;
var labelTertiaryStandardColorDisabled$1 = LABEL_TERTIARY_STANDARD_COLOR_DISABLED$1;
var labelTertiaryStandardColorSecondary$1 = LABEL_TERTIARY_STANDARD_COLOR_SECONDARY$1;
var labelTertiaryStandardColorPrimaryHover$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER$1;
var labelTertiaryStandardColorInteractive$1 = LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE$1;
var labelTertiaryEmphasizedColorPrimaryDark$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var labelTertiaryEmphasizedColorPrimaryLight$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT$1;
var labelTertiaryEmphasizedColorDisabled$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED$1;
var labelTertiaryEmphasizedColorSecondary$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY$1;
var labelTertiaryEmphasizedColorPrimaryHover$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER$1;
var labelTertiaryEmphasizedColorInteractive$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE$1;
var labelSupportiveColorPrimaryDark$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK$1;
var labelSupportiveColorPrimaryLight$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT$1;
var labelSupportiveColorDisabled$1 = LABEL_SUPPORTIVE_COLOR_DISABLED$1;
var labelSupportiveColorSecondary$1 = LABEL_SUPPORTIVE_COLOR_SECONDARY$1;
var labelSupportiveColorPrimaryHover$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER$1;
var labelSupportiveColorInteractive$1 = LABEL_SUPPORTIVE_COLOR_INTERACTIVE$1;
var bodyStandardColorPlaceholder$1 = BODY_STANDARD_COLOR_PLACEHOLDER$1;
var bodyStandardColorDisabled$1 = BODY_STANDARD_COLOR_DISABLED$1;
var bodyStandardColorError$1 = BODY_STANDARD_COLOR_ERROR$1;
var bodyStandardColorPrimaryDark$1 = BODY_STANDARD_COLOR_PRIMARY_DARK$1;
var bodyStandardColorPromotional$1 = BODY_STANDARD_COLOR_PROMOTIONAL$1;
var bodyStandardColorSecondary$1 = BODY_STANDARD_COLOR_SECONDARY$1;
var bodyStandardColorPrimaryHover$1 = BODY_STANDARD_COLOR_PRIMARY_HOVER$1;
var bodyEmphasizedColorPlaceholder$1 = BODY_EMPHASIZED_COLOR_PLACEHOLDER$1;
var bodyEmphasizedColorDisabled$1 = BODY_EMPHASIZED_COLOR_DISABLED$1;
var bodyEmphasizedColorError$1 = BODY_EMPHASIZED_COLOR_ERROR$1;
var bodyEmphasizedColorPrimaryDark$1 = BODY_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var bodyEmphasizedColorPromotional$1 = BODY_EMPHASIZED_COLOR_PROMOTIONAL$1;
var bodyEmphasizedColorSecondary$1 = BODY_EMPHASIZED_COLOR_SECONDARY$1;
var bodyEmphasizedColorPrimaryHover$1 = BODY_EMPHASIZED_COLOR_PRIMARY_HOVER$1;
var priceSmallColorPrimaryDark$1 = PRICE_SMALL_COLOR_PRIMARY_DARK$1;
var priceSmallColorPromotional$1 = PRICE_SMALL_COLOR_PROMOTIONAL$1;
var priceMediumColorPrimaryDark$1 = PRICE_MEDIUM_COLOR_PRIMARY_DARK$1;
var priceMediumColorPromotional$1 = PRICE_MEDIUM_COLOR_PROMOTIONAL$1;
var priceLargeColorPrimaryDark$1 = PRICE_LARGE_COLOR_PRIMARY_DARK$1;
var priceLargeColorPromotional$1 = PRICE_LARGE_COLOR_PROMOTIONAL$1;
var hintColorPrimaryDark$1 = HINT_COLOR_PRIMARY_DARK$1;
var hintColorSecondary$1 = HINT_COLOR_SECONDARY$1;
var hintColorDisabled$1 = HINT_COLOR_DISABLED$1;
var hintColorError$1 = HINT_COLOR_ERROR$1;
var typographyColor$2 = {
  display1_ColorDisabled: display1_ColorDisabled$1,
  display1_ColorPrimaryDark: display1_ColorPrimaryDark$1,
  display2_ColorDisabled: display2_ColorDisabled$1,
  display2_ColorPrimaryDark: display2_ColorPrimaryDark$1,
  display3_ColorDisabled: display3_ColorDisabled$1,
  display3_ColorPrimaryDark: display3_ColorPrimaryDark$1,
  display4_ColorDisabled: display4_ColorDisabled$1,
  display4_ColorPrimaryDark: display4_ColorPrimaryDark$1,
  titleColorDisabled: titleColorDisabled$1,
  titleColorPrimaryDark: titleColorPrimaryDark$1,
  titleColorPromotional: titleColorPromotional$1,
  flagColorSecondary: flagColorSecondary$1,
  badgeLargeColorPrimaryDark: badgeLargeColorPrimaryDark$1,
  badgeSmallColorPrimaryDark: badgeSmallColorPrimaryDark$1,
  badgeLargeColorPrimaryLight: badgeLargeColorPrimaryLight$1,
  badgeSmallColorPrimaryLight: badgeSmallColorPrimaryLight$1,
  captionStandardColorDisabled: captionStandardColorDisabled$1,
  captionStandardColorError: captionStandardColorError$1,
  captionStandardColorPrimaryDark: captionStandardColorPrimaryDark$1,
  captionStandardColorPrimaryLight: captionStandardColorPrimaryLight$1,
  captionStandardColorPromotional: captionStandardColorPromotional$1,
  captionStandardColorSecondary: captionStandardColorSecondary$1,
  captionEmphasizedColorDisabled: captionEmphasizedColorDisabled$1,
  captionEmphasizedColorError: captionEmphasizedColorError$1,
  captionEmphasizedColorPrimaryDark: captionEmphasizedColorPrimaryDark$1,
  captionEmphasizedColorPrimaryLight: captionEmphasizedColorPrimaryLight$1,
  captionEmphasizedColorPromotional: captionEmphasizedColorPromotional$1,
  captionEmphasizedColorSecondary: captionEmphasizedColorSecondary$1,
  labelPrimaryColorPrimaryDark: labelPrimaryColorPrimaryDark$1,
  labelPrimaryColorPrimaryLight: labelPrimaryColorPrimaryLight$1,
  labelPrimaryColorDisabled: labelPrimaryColorDisabled$1,
  labelPrimaryColorSecondary: labelPrimaryColorSecondary$1,
  labelPrimaryColorPrimaryHover: labelPrimaryColorPrimaryHover$1,
  labelPrimaryColorInteractive: labelPrimaryColorInteractive$1,
  labelSecondaryColorPrimaryDark: labelSecondaryColorPrimaryDark$1,
  labelSecondaryColorPrimaryLight: labelSecondaryColorPrimaryLight$1,
  labelSecondaryColorDisabled: labelSecondaryColorDisabled$1,
  labelSecondaryColorSecondary: labelSecondaryColorSecondary$1,
  labelSecondaryColorPrimaryHover: labelSecondaryColorPrimaryHover$1,
  labelSecondaryColorInteractive: labelSecondaryColorInteractive$1,
  labelTertiaryStandardColorPrimaryDark: labelTertiaryStandardColorPrimaryDark$1,
  labelTertiaryStandardColorPrimaryLight: labelTertiaryStandardColorPrimaryLight$1,
  labelTertiaryStandardColorDisabled: labelTertiaryStandardColorDisabled$1,
  labelTertiaryStandardColorSecondary: labelTertiaryStandardColorSecondary$1,
  labelTertiaryStandardColorPrimaryHover: labelTertiaryStandardColorPrimaryHover$1,
  labelTertiaryStandardColorInteractive: labelTertiaryStandardColorInteractive$1,
  labelTertiaryEmphasizedColorPrimaryDark: labelTertiaryEmphasizedColorPrimaryDark$1,
  labelTertiaryEmphasizedColorPrimaryLight: labelTertiaryEmphasizedColorPrimaryLight$1,
  labelTertiaryEmphasizedColorDisabled: labelTertiaryEmphasizedColorDisabled$1,
  labelTertiaryEmphasizedColorSecondary: labelTertiaryEmphasizedColorSecondary$1,
  labelTertiaryEmphasizedColorPrimaryHover: labelTertiaryEmphasizedColorPrimaryHover$1,
  labelTertiaryEmphasizedColorInteractive: labelTertiaryEmphasizedColorInteractive$1,
  labelSupportiveColorPrimaryDark: labelSupportiveColorPrimaryDark$1,
  labelSupportiveColorPrimaryLight: labelSupportiveColorPrimaryLight$1,
  labelSupportiveColorDisabled: labelSupportiveColorDisabled$1,
  labelSupportiveColorSecondary: labelSupportiveColorSecondary$1,
  labelSupportiveColorPrimaryHover: labelSupportiveColorPrimaryHover$1,
  labelSupportiveColorInteractive: labelSupportiveColorInteractive$1,
  bodyStandardColorPlaceholder: bodyStandardColorPlaceholder$1,
  bodyStandardColorDisabled: bodyStandardColorDisabled$1,
  bodyStandardColorError: bodyStandardColorError$1,
  bodyStandardColorPrimaryDark: bodyStandardColorPrimaryDark$1,
  bodyStandardColorPromotional: bodyStandardColorPromotional$1,
  bodyStandardColorSecondary: bodyStandardColorSecondary$1,
  bodyStandardColorPrimaryHover: bodyStandardColorPrimaryHover$1,
  bodyEmphasizedColorPlaceholder: bodyEmphasizedColorPlaceholder$1,
  bodyEmphasizedColorDisabled: bodyEmphasizedColorDisabled$1,
  bodyEmphasizedColorError: bodyEmphasizedColorError$1,
  bodyEmphasizedColorPrimaryDark: bodyEmphasizedColorPrimaryDark$1,
  bodyEmphasizedColorPromotional: bodyEmphasizedColorPromotional$1,
  bodyEmphasizedColorSecondary: bodyEmphasizedColorSecondary$1,
  bodyEmphasizedColorPrimaryHover: bodyEmphasizedColorPrimaryHover$1,
  priceSmallColorPrimaryDark: priceSmallColorPrimaryDark$1,
  priceSmallColorPromotional: priceSmallColorPromotional$1,
  priceMediumColorPrimaryDark: priceMediumColorPrimaryDark$1,
  priceMediumColorPromotional: priceMediumColorPromotional$1,
  priceLargeColorPrimaryDark: priceLargeColorPrimaryDark$1,
  priceLargeColorPromotional: priceLargeColorPromotional$1,
  hintColorPrimaryDark: hintColorPrimaryDark$1,
  hintColorSecondary: hintColorSecondary$1,
  hintColorDisabled: hintColorDisabled$1,
  hintColorError: hintColorError$1
};

var jsEnvVariables = {
  color: color$1,
  typographyColor: typographyColor$2
};
var jsEnvVariables_1 = jsEnvVariables.color;
var jsEnvVariables_2 = jsEnvVariables.typographyColor;

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': jsEnvVariables,
  __moduleExports: jsEnvVariables,
  color: jsEnvVariables_1,
  typographyColor: jsEnvVariables_2
});

var iconMap = {
  'account': function account() {
    return import('./account-icon-881c37ed.js');
  },
  'arrow-down': function arrowDown() {
    return import('./arrow-down-icon-7ac3f29e.js');
  },
  'attention': function attention() {
    return import('./attention-icon-a261d7fe.js');
  },
  'cancel': function cancel() {
    return import('./cancel-icon-d03454ca.js');
  },
  'cart': function cart() {
    return import('./cart-icon-789966b9.js');
  },
  'check-large': function checkLarge() {
    return import('./check-large-icon-93e4eac6.js');
  },
  'chevron-down': function chevronDown() {
    return import('./chevron-down-icon-3e69936c.js');
  },
  'chevron-left': function chevronLeft() {
    return import('./chevron-left-icon-f2d0335c.js');
  },
  'chevron-right-32': function chevronRight32() {
    return import('./chevron-right-32-icon-8d2f38f6.js');
  },
  'chevron-right': function chevronRight() {
    return import('./chevron-right-icon-28276854.js');
  },
  'chevron-up': function chevronUp() {
    return import('./chevron-up-icon-506651aa.js');
  },
  'close-big': function closeBig() {
    return import('./close-big-icon-605080af.js');
  },
  'close': function close() {
    return import('./close-icon-290220f9.js');
  },
  'copy': function copy() {
    return import('./copy-icon-7b6f5215.js');
  },
  'coupon': function coupon() {
    return import('./coupon-icon-05bec96b.js');
  },
  'credit-card': function creditCard() {
    return import('./credit-card-icon-8656318f.js');
  },
  'delete': function _delete() {
    return import('./delete-icon-2fa84017.js');
  },
  'external-link': function externalLink() {
    return import('./external-link-icon-3fc38273.js');
  },
  'feature-menu': function featureMenu() {
    return import('./feature-menu-icon-f71e5681.js');
  },
  'filter-opened': function filterOpened() {
    return import('./filter-opened-icon-8aacc499.js');
  },
  'filter': function filter() {
    return import('./filter-icon-ca563416.js');
  },
  'gift-card': function giftCard() {
    return import('./gift-card-icon-b39d51dd.js');
  },
  'gift': function gift() {
    return import('./gift-icon-5a88489c.js');
  },
  'global': function global() {
    return import('./global-icon-bfeebf64.js');
  },
  'heart-filled': function heartFilled() {
    return import('./heart-filled-icon-02f45d4b.js');
  },
  'heart': function heart() {
    return import('./heart-icon-fede7815.js');
  },
  'help': function help() {
    return import('./help-icon-1c78794b.js');
  },
  'information': function information() {
    return import('./information-icon-5caead95.js');
  },
  'item': function item() {
    return import('./item-icon-073ec290.js');
  },
  'location': function location() {
    return import('./location-icon-cbb1fff3.js');
  },
  'lock-locked': function lockLocked() {
    return import('./lock-locked-icon-1dd05471.js');
  },
  'menu': function menu() {
    return import('./menu-icon-b4b3c97f.js');
  },
  'minus': function minus() {
    return import('./minus-icon-7b2fe787.js');
  },
  'no-video': function noVideo() {
    return import('./no-video-icon-4c0a6b97.js');
  },
  'notification': function notification() {
    return import('./notification-icon-c4f86380.js');
  },
  'o2o': function o2o() {
    return import('./o2o-icon-dc5193c1.js');
  },
  'parking': function parking() {
    return import('./parking-icon-25c67c2d.js');
  },
  'pause': function pause() {
    return import('./pause-icon-8be704aa.js');
  },
  'phone': function phone() {
    return import('./phone-icon-eba11e9e.js');
  },
  'play': function play() {
    return import('./play-icon-ae4005a6.js');
  },
  'plus': function plus() {
    return import('./plus-icon-7bfc7b83.js');
  },
  'product-search': function productSearch() {
    return import('./product-search-icon-403e9302.js');
  },
  'product': function product() {
    return import('./product-icon-e4f9daa1.js');
  },
  'prohibited': function prohibited() {
    return import('./prohibited-icon-9d0de9be.js');
  },
  'quotation-end': function quotationEnd() {
    return import('./quotation-end-icon-0d3d13a4.js');
  },
  'quotation-start': function quotationStart() {
    return import('./quotation-start-icon-e2a97dd9.js');
  },
  'search': function search() {
    return import('./search-icon-9ec9c775.js');
  },
  'semi-order': function semiOrder() {
    return import('./semi-order-icon-53d604aa.js');
  },
  'share': function share() {
    return import('./share-icon-ea53f71a.js');
  },
  'size-chart': function sizeChart() {
    return import('./size-chart-icon-c11eba4a.js');
  },
  'size': function size() {
    return import('./size-icon-8e042eba.js');
  },
  'sort': function sort() {
    return import('./sort-icon-0da64098.js');
  },
  'star-filled': function starFilled() {
    return import('./star-filled-icon-7a3f8aae.js');
  },
  'star-half-filled': function starHalfFilled() {
    return import('./star-half-filled-icon-95deb7f5.js');
  },
  'store': function store() {
    return import('./store-icon-4a9ed7d8.js');
  },
  'verified-badge': function verifiedBadge() {
    return import('./verified-badge-icon-c57ba61f.js');
  },
  'visual-search': function visualSearch() {
    return import('./visual-search-icon-3d072b77.js');
  },
  'warehouse': function warehouse() {
    return import('./warehouse-icon-0c4b370a.js');
  }
};

/**
 * lib.js is the index for the library produced by ds-create-bundles. Components
 * should be organized and exposed through this file.
 */
var cssEnvironmentVariables = cssEnvVariables_1;

export { cssEnvironmentVariables, iconMap, index as jsEnvironmentVariables };
